// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/templates.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "api.devplan.types.templates";

export enum TemplateStatus {
  UNKNOWN_STATUS = 0,
  ACTIVE = 1,
  DRAFT = 2,
  ARCHIVED = 3,
}

export function templateStatusFromJSON(object: any): TemplateStatus {
  switch (object) {
    case 0:
    case "UNKNOWN_STATUS":
      return TemplateStatus.UNKNOWN_STATUS;
    case 1:
    case "ACTIVE":
      return TemplateStatus.ACTIVE;
    case 2:
    case "DRAFT":
      return TemplateStatus.DRAFT;
    case 3:
    case "ARCHIVED":
      return TemplateStatus.ARCHIVED;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum TemplateStatus");
  }
}

export function templateStatusToJSON(object: TemplateStatus): string {
  switch (object) {
    case TemplateStatus.UNKNOWN_STATUS:
      return "UNKNOWN_STATUS";
    case TemplateStatus.ACTIVE:
      return "ACTIVE";
    case TemplateStatus.DRAFT:
      return "DRAFT";
    case TemplateStatus.ARCHIVED:
      return "ARCHIVED";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum TemplateStatus");
  }
}

export enum ModelType {
  DEFAULT = 0,
  OPEN_AI = 1,
  GROQ = 2,
  ANTHROPIC = 3,
  GOOGLE = 4,
  AZURE_OPEN_AI = 5,
  AZURE_USEAST2_OPEN_AI = 6,
}

export function modelTypeFromJSON(object: any): ModelType {
  switch (object) {
    case 0:
    case "DEFAULT":
      return ModelType.DEFAULT;
    case 1:
    case "OPEN_AI":
      return ModelType.OPEN_AI;
    case 2:
    case "GROQ":
      return ModelType.GROQ;
    case 3:
    case "ANTHROPIC":
      return ModelType.ANTHROPIC;
    case 4:
    case "GOOGLE":
      return ModelType.GOOGLE;
    case 5:
    case "AZURE_OPEN_AI":
      return ModelType.AZURE_OPEN_AI;
    case 6:
    case "AZURE_USEAST2_OPEN_AI":
      return ModelType.AZURE_USEAST2_OPEN_AI;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ModelType");
  }
}

export function modelTypeToJSON(object: ModelType): string {
  switch (object) {
    case ModelType.DEFAULT:
      return "DEFAULT";
    case ModelType.OPEN_AI:
      return "OPEN_AI";
    case ModelType.GROQ:
      return "GROQ";
    case ModelType.ANTHROPIC:
      return "ANTHROPIC";
    case ModelType.GOOGLE:
      return "GOOGLE";
    case ModelType.AZURE_OPEN_AI:
      return "AZURE_OPEN_AI";
    case ModelType.AZURE_USEAST2_OPEN_AI:
      return "AZURE_USEAST2_OPEN_AI";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ModelType");
  }
}

export enum CodeAssistantType {
  ANY = 0,
  CURSOR = 1,
  JUNIE = 2,
  WINDSURF = 3,
}

export function codeAssistantTypeFromJSON(object: any): CodeAssistantType {
  switch (object) {
    case 0:
    case "ANY":
      return CodeAssistantType.ANY;
    case 1:
    case "CURSOR":
      return CodeAssistantType.CURSOR;
    case 2:
    case "JUNIE":
      return CodeAssistantType.JUNIE;
    case 3:
    case "WINDSURF":
      return CodeAssistantType.WINDSURF;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum CodeAssistantType");
  }
}

export function codeAssistantTypeToJSON(object: CodeAssistantType): string {
  switch (object) {
    case CodeAssistantType.ANY:
      return "ANY";
    case CodeAssistantType.CURSOR:
      return "CURSOR";
    case CodeAssistantType.JUNIE:
      return "JUNIE";
    case CodeAssistantType.WINDSURF:
      return "WINDSURF";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum CodeAssistantType");
  }
}

export interface TemplateInputField {
  /** Name of the input field to be shown in the UI. */
  name: string;
  /** Description of the input field to be shown in the UI. */
  description: string;
}

export interface TemplateInitialInput {
  /** Fields that should be provided on the initial input for the templated entity. */
  fields: TemplateInputField[];
}

export interface ModelConfig {
  type: ModelType;
  name: string;
  temperature: number;
  disableStreaming: boolean;
  structOutputMethod?: string | undefined;
  strict: boolean;
  verbosity?: string | undefined;
  reasoningEffort?: string | undefined;
}

export interface PromptTemplate {
  systemPrompt: string;
  userMessage: string;
  modelConfig: ModelConfig | undefined;
}

export interface DocumentTemplate {
  id: string;
  meta: TemplateMeta | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  type:
    | { $case: "prd"; value: PrdTemplate }
    | { $case: "projectPlan"; value: ProjectPlanTemplate }
    | { $case: "feature"; value: FeatureTemplate }
    | { $case: "planSubItem"; value: PlanSubItemTemplate }
    | { $case: "customDocument"; value: CustomDocumentTemplate }
    | { $case: "codingAssistant"; value: CodingAssistantTemplate }
    | undefined;
}

export interface TemplateMeta {
  /** Name of the template. */
  name: string;
  /** Descriptions of the template. */
  description: string;
  /** Status of the template. */
  status: TemplateStatus;
  /** Categories that determine which roles can edit documents created from this template */
  categories: string[];
  /**
   * If true, then the documents with this template will also have a category "draft" added to allow
   * edits by anyone with daft edits permissions.
   */
  partOfDraft: boolean;
}

export interface FeatureTemplate {
  /** Initial input for generation. */
  initialInput:
    | TemplateInitialInput
    | undefined;
  /** Number of critique loops to perform on initial generation */
  initialCritiqueLoops: number;
  /** Number of critique loops to perform on subsequent generations of the tasks. */
  critiqueLoops: number;
  /** Templates the prompt for initial the chatting node. */
  chatPrompt: PromptTemplate | undefined;
  generationPlan?:
    | GenerationPlan
    | undefined;
  /** Templates the prompt for request generating the tasks. */
  generationPrompt:
    | PromptTemplate
    | undefined;
  /** Templates the prompt for the critique request. */
  critiquePrompt:
    | PromptTemplate
    | undefined;
  /** Templates the prompt for the chatting node after generation is done. */
  confirmationPrompt:
    | PromptTemplate
    | undefined;
  /** Templates the prompt to generate a description for the feature. */
  descriptionPrompt?: PromptTemplate | undefined;
}

export interface DocumentSection {
  /** Name of the verification session. */
  name: string;
  /** Description of the verification section. */
  description: string;
  /** Hints about how this section should be formatted. */
  formattingHints: string;
}

export interface SummarySections {
  sections: DocumentSection[];
  skip: boolean;
}

export interface FullDocumentSections {
  sections: DocumentSection[];
}

export interface GenerationPlan {
  enabled: boolean;
  /** If set to true, then plan should be run before every single generation, otherwise - only before the first one. */
  everyRun: boolean;
  prompt?: PromptTemplate | undefined;
}

export interface PrdTemplate {
  /** Initial input for generation. */
  initialInput: TemplateInitialInput | undefined;
  summarySections: SummarySections | undefined;
  fullSections:
    | FullDocumentSections
    | undefined;
  /** Templates the prompt for initial the chatting node. */
  summaryChatPrompt: PromptTemplate | undefined;
  summaryConfirmationPrompt: PromptTemplate | undefined;
  confirmSummaryTitle?: string | undefined;
  fullInitialPrompt: PromptTemplate | undefined;
  fullChatPrompt: PromptTemplate | undefined;
  fullConfirmationPrompt: PromptTemplate | undefined;
  writePlan?:
    | GenerationPlan
    | undefined;
  /** Templates the prompt for request generating the tasks. */
  writePrompt:
    | PromptTemplate
    | undefined;
  /** Templates the prompt for the critique request. */
  critiquePrompt:
    | PromptTemplate
    | undefined;
  /** Number of critique loops to perform on initial generation */
  initialCritiqueLoops: number;
  /** Number of critique loops to perform on subsequent generations of the tasks. */
  critiqueLoops: number;
}

/** Sub item (aka task) template */
export interface PlanSubItemTemplate {
  /** Templates the prompt for initial the chatting node. */
  chatPrompt:
    | PromptTemplate
    | undefined;
  /** Templates the prompt for the chatting node after chat tools are processed. */
  confirmationPrompt:
    | PromptTemplate
    | undefined;
  /** Templates the prompt to generate a description for the task. */
  descriptionPrompt?: PromptTemplate | undefined;
}

export interface ProjectPlanTemplate {
  /** Number of critique loops to perform on initial generation */
  initialCritiqueLoops: number;
  /** Number of critique loops to perform on subsequent generations of the tasks. */
  critiqueLoops: number;
  /** Templates the prompt for initial the chatting node. */
  chatPrompt: PromptTemplate | undefined;
  generationPlan?:
    | GenerationPlan
    | undefined;
  /** Templates the prompt for request generating the tasks. */
  generationPrompt:
    | PromptTemplate
    | undefined;
  /** Templates the prompt for the critique request. */
  critiquePrompt:
    | PromptTemplate
    | undefined;
  /** Templates the prompt for the chatting node after generation is done. */
  confirmationPrompt: PromptTemplate | undefined;
}

export interface SuggestionsTemplate {
  id: string;
  meta: TemplateMeta | undefined;
  details: SuggestionsTemplateDetails | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
}

export interface SuggestionsTemplateDetails {
  /** Templates the prompt for generating suggestions that can be accepted directly by the user. */
  acceptSuggestionsPrompt?:
    | PromptTemplate
    | undefined;
  /** Templates the prompt for generating suggestions that should be answered by the user. */
  responseSuggestionsPrompt?: PromptTemplate | undefined;
}

export interface ProjectTemplateInfo {
  templateId: string;
  suggestionsTemplateId?: string | undefined;
}

export interface ProjectTemplate {
  id: string;
  meta: TemplateMeta | undefined;
  details: ProjectTemplateDetails | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
}

export interface ProjectTabLayout {
  enabled: boolean;
  promptPrefixes: ProjectTabLayout_PromptPrefixes | undefined;
}

export interface ProjectTabLayout_PromptPrefixes {
  productAgent: string;
  devAgent: string;
  taskPromptAgent: string;
  productBriefAgent: string;
  techBriefAgent: string;
  userStoriesAgent: string;
  userStoryTasksAgent: string;
  projectTasksAgent: string;
  discoveryAgent: string;
  discoveryBriefAgent: string;
  riceScoreAgent: string;
}

export interface ProjectTemplateDetails {
  requirements: ProjectTemplateDetails_Requirements | undefined;
  plan: ProjectTemplateDetails_Plan | undefined;
  planItem: ProjectTemplateDetails_PlanItem | undefined;
  planSubItem:
    | ProjectTemplateDetails_PlanSubItem
    | undefined;
  /** Order in quick launch. If it is -1, then no need to show at all in quick launch. */
  quickLaunchOrder: number;
  /** Full path to the icon if any */
  iconPath?: string | undefined;
  techBrief?:
    | ProjectTemplateDetails_TechBrief
    | undefined;
  /** If true, tasks won't be generated automatically */
  skipAutoTasks: boolean;
  tabConfigs: ProjectTemplateDetails_ProjectTemplateTabConfig[];
  tabLayout?: ProjectTabLayout | undefined;
  taskPrompt?: ProjectTemplateDetails_TaskPrompt | undefined;
  userStoryPrompt?: ProjectTemplateDetails_UserStoryPrompt | undefined;
}

export interface ProjectTemplateDetails_Requirements {
  info: ProjectTemplateInfo | undefined;
}

export interface ProjectTemplateDetails_Plan {
  info: ProjectTemplateInfo | undefined;
  hide: boolean;
}

export interface ProjectTemplateDetails_PlanItem {
  info: ProjectTemplateInfo | undefined;
}

export interface ProjectTemplateDetails_PlanSubItem {
  info: ProjectTemplateInfo | undefined;
}

export interface ProjectTemplateDetails_TechBrief {
  info: ProjectTemplateInfo | undefined;
}

export interface ProjectTemplateDetails_TaskPrompt {
  info: ProjectTemplateInfo | undefined;
}

export interface ProjectTemplateDetails_UserStoryPrompt {
  info: ProjectTemplateInfo | undefined;
}

export interface ProjectTemplateDetails_ProjectTemplateTabConfig {
  templateId: string;
  order: number;
  /** Whether this custom doc should be shown as a tab (true) or be part of the dropdown (false) */
  asTab: boolean;
}

export interface CustomDocumentSettings {
  iconPath?:
    | string
    | undefined;
  /** If true, only one document with given template type is allowed in a project. */
  unique: boolean;
  showAsTab: boolean;
  noGenerationOnStart: boolean;
  initialMessage?: string | undefined;
  initialSystemPrompt?: string | undefined;
}

export interface CustomDocumentTemplate {
  settings: CustomDocumentSettings | undefined;
  generationPlan?:
    | GenerationPlan
    | undefined;
  /** Templates the prompt for request generating the document. */
  generationPrompt:
    | PromptTemplate
    | undefined;
  /** Templates the prompt for the critique request. */
  critiquePrompt:
    | PromptTemplate
    | undefined;
  /** Number of critique loops to perform on initial generation */
  initialCritiqueLoops: number;
  /** Number of critique loops to perform on subsequent generations */
  critiqueLoops: number;
  /** Templates the prompt for initial the chatting node. */
  chatPrompt:
    | PromptTemplate
    | undefined;
  /** Templates the prompt for the chatting node after chat tools are processed. */
  confirmationPrompt: PromptTemplate | undefined;
}

export interface CodeAssistantRule {
  name: string;
  extension: string;
  assistantType: CodeAssistantType;
  type: { $case: "templateId"; value: string } | { $case: "static"; value: string } | undefined;
}

export interface CodingAssistantTemplate {
  fullPromptTemplateId?: string | undefined;
  perFeatureTemplateId?: string | undefined;
  steppedPerFeatureTemplateId?: string | undefined;
  ruleFiles: CodeAssistantRule[];
}

function createBaseTemplateInputField(): TemplateInputField {
  return { name: "", description: "" };
}

export const TemplateInputField: MessageFns<TemplateInputField> = {
  encode(message: TemplateInputField, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TemplateInputField {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTemplateInputField();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TemplateInputField {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: TemplateInputField): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create(base?: DeepPartial<TemplateInputField>): TemplateInputField {
    return TemplateInputField.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TemplateInputField>): TemplateInputField {
    const message = createBaseTemplateInputField();
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseTemplateInitialInput(): TemplateInitialInput {
  return { fields: [] };
}

export const TemplateInitialInput: MessageFns<TemplateInitialInput> = {
  encode(message: TemplateInitialInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fields) {
      TemplateInputField.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TemplateInitialInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTemplateInitialInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fields.push(TemplateInputField.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TemplateInitialInput {
    return {
      fields: globalThis.Array.isArray(object?.fields)
        ? object.fields.map((e: any) => TemplateInputField.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TemplateInitialInput): unknown {
    const obj: any = {};
    if (message.fields?.length) {
      obj.fields = message.fields.map((e) => TemplateInputField.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<TemplateInitialInput>): TemplateInitialInput {
    return TemplateInitialInput.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TemplateInitialInput>): TemplateInitialInput {
    const message = createBaseTemplateInitialInput();
    message.fields = object.fields?.map((e) => TemplateInputField.fromPartial(e)) || [];
    return message;
  },
};

function createBaseModelConfig(): ModelConfig {
  return {
    type: 0,
    name: "",
    temperature: 0,
    disableStreaming: false,
    structOutputMethod: undefined,
    strict: false,
    verbosity: undefined,
    reasoningEffort: undefined,
  };
}

export const ModelConfig: MessageFns<ModelConfig> = {
  encode(message: ModelConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.temperature !== 0) {
      writer.uint32(29).float(message.temperature);
    }
    if (message.disableStreaming !== false) {
      writer.uint32(32).bool(message.disableStreaming);
    }
    if (message.structOutputMethod !== undefined) {
      writer.uint32(42).string(message.structOutputMethod);
    }
    if (message.strict !== false) {
      writer.uint32(48).bool(message.strict);
    }
    if (message.verbosity !== undefined) {
      writer.uint32(58).string(message.verbosity);
    }
    if (message.reasoningEffort !== undefined) {
      writer.uint32(66).string(message.reasoningEffort);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModelConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModelConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.temperature = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.disableStreaming = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.structOutputMethod = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.strict = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.verbosity = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.reasoningEffort = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModelConfig {
    return {
      type: isSet(object.type) ? modelTypeFromJSON(object.type) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      temperature: isSet(object.temperature) ? globalThis.Number(object.temperature) : 0,
      disableStreaming: isSet(object.disableStreaming)
        ? globalThis.Boolean(object.disableStreaming)
        : isSet(object.disable_streaming)
        ? globalThis.Boolean(object.disable_streaming)
        : false,
      structOutputMethod: isSet(object.structOutputMethod)
        ? globalThis.String(object.structOutputMethod)
        : isSet(object.struct_output_method)
        ? globalThis.String(object.struct_output_method)
        : undefined,
      strict: isSet(object.strict) ? globalThis.Boolean(object.strict) : false,
      verbosity: isSet(object.verbosity) ? globalThis.String(object.verbosity) : undefined,
      reasoningEffort: isSet(object.reasoningEffort)
        ? globalThis.String(object.reasoningEffort)
        : isSet(object.reasoning_effort)
        ? globalThis.String(object.reasoning_effort)
        : undefined,
    };
  },

  toJSON(message: ModelConfig): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = modelTypeToJSON(message.type);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.temperature !== 0) {
      obj.temperature = message.temperature;
    }
    if (message.disableStreaming !== false) {
      obj.disableStreaming = message.disableStreaming;
    }
    if (message.structOutputMethod !== undefined) {
      obj.structOutputMethod = message.structOutputMethod;
    }
    if (message.strict !== false) {
      obj.strict = message.strict;
    }
    if (message.verbosity !== undefined) {
      obj.verbosity = message.verbosity;
    }
    if (message.reasoningEffort !== undefined) {
      obj.reasoningEffort = message.reasoningEffort;
    }
    return obj;
  },

  create(base?: DeepPartial<ModelConfig>): ModelConfig {
    return ModelConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ModelConfig>): ModelConfig {
    const message = createBaseModelConfig();
    message.type = object.type ?? 0;
    message.name = object.name ?? "";
    message.temperature = object.temperature ?? 0;
    message.disableStreaming = object.disableStreaming ?? false;
    message.structOutputMethod = object.structOutputMethod ?? undefined;
    message.strict = object.strict ?? false;
    message.verbosity = object.verbosity ?? undefined;
    message.reasoningEffort = object.reasoningEffort ?? undefined;
    return message;
  },
};

function createBasePromptTemplate(): PromptTemplate {
  return { systemPrompt: "", userMessage: "", modelConfig: undefined };
}

export const PromptTemplate: MessageFns<PromptTemplate> = {
  encode(message: PromptTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.systemPrompt !== "") {
      writer.uint32(10).string(message.systemPrompt);
    }
    if (message.userMessage !== "") {
      writer.uint32(18).string(message.userMessage);
    }
    if (message.modelConfig !== undefined) {
      ModelConfig.encode(message.modelConfig, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PromptTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePromptTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.systemPrompt = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.userMessage = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.modelConfig = ModelConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PromptTemplate {
    return {
      systemPrompt: isSet(object.systemPrompt)
        ? globalThis.String(object.systemPrompt)
        : isSet(object.system_prompt)
        ? globalThis.String(object.system_prompt)
        : "",
      userMessage: isSet(object.userMessage)
        ? globalThis.String(object.userMessage)
        : isSet(object.user_message)
        ? globalThis.String(object.user_message)
        : "",
      modelConfig: isSet(object.modelConfig)
        ? ModelConfig.fromJSON(object.modelConfig)
        : isSet(object.model_config)
        ? ModelConfig.fromJSON(object.model_config)
        : undefined,
    };
  },

  toJSON(message: PromptTemplate): unknown {
    const obj: any = {};
    if (message.systemPrompt !== "") {
      obj.systemPrompt = message.systemPrompt;
    }
    if (message.userMessage !== "") {
      obj.userMessage = message.userMessage;
    }
    if (message.modelConfig !== undefined) {
      obj.modelConfig = ModelConfig.toJSON(message.modelConfig);
    }
    return obj;
  },

  create(base?: DeepPartial<PromptTemplate>): PromptTemplate {
    return PromptTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PromptTemplate>): PromptTemplate {
    const message = createBasePromptTemplate();
    message.systemPrompt = object.systemPrompt ?? "";
    message.userMessage = object.userMessage ?? "";
    message.modelConfig = (object.modelConfig !== undefined && object.modelConfig !== null)
      ? ModelConfig.fromPartial(object.modelConfig)
      : undefined;
    return message;
  },
};

function createBaseDocumentTemplate(): DocumentTemplate {
  return { id: "", meta: undefined, createdAt: undefined, updatedAt: undefined, type: undefined };
}

export const DocumentTemplate: MessageFns<DocumentTemplate> = {
  encode(message: DocumentTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.meta !== undefined) {
      TemplateMeta.encode(message.meta, writer.uint32(18).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(26).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(34).fork()).join();
    }
    switch (message.type?.$case) {
      case "prd":
        PrdTemplate.encode(message.type.value, writer.uint32(802).fork()).join();
        break;
      case "projectPlan":
        ProjectPlanTemplate.encode(message.type.value, writer.uint32(810).fork()).join();
        break;
      case "feature":
        FeatureTemplate.encode(message.type.value, writer.uint32(818).fork()).join();
        break;
      case "planSubItem":
        PlanSubItemTemplate.encode(message.type.value, writer.uint32(826).fork()).join();
        break;
      case "customDocument":
        CustomDocumentTemplate.encode(message.type.value, writer.uint32(834).fork()).join();
        break;
      case "codingAssistant":
        CodingAssistantTemplate.encode(message.type.value, writer.uint32(842).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DocumentTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDocumentTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.meta = TemplateMeta.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.type = { $case: "prd", value: PrdTemplate.decode(reader, reader.uint32()) };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.type = { $case: "projectPlan", value: ProjectPlanTemplate.decode(reader, reader.uint32()) };
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.type = { $case: "feature", value: FeatureTemplate.decode(reader, reader.uint32()) };
          continue;
        }
        case 103: {
          if (tag !== 826) {
            break;
          }

          message.type = { $case: "planSubItem", value: PlanSubItemTemplate.decode(reader, reader.uint32()) };
          continue;
        }
        case 104: {
          if (tag !== 834) {
            break;
          }

          message.type = { $case: "customDocument", value: CustomDocumentTemplate.decode(reader, reader.uint32()) };
          continue;
        }
        case 105: {
          if (tag !== 842) {
            break;
          }

          message.type = { $case: "codingAssistant", value: CodingAssistantTemplate.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DocumentTemplate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      meta: isSet(object.meta) ? TemplateMeta.fromJSON(object.meta) : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      type: isSet(object.prd)
        ? { $case: "prd", value: PrdTemplate.fromJSON(object.prd) }
        : isSet(object.projectPlan)
        ? { $case: "projectPlan", value: ProjectPlanTemplate.fromJSON(object.projectPlan) }
        : isSet(object.project_plan)
        ? { $case: "projectPlan", value: ProjectPlanTemplate.fromJSON(object.project_plan) }
        : isSet(object.feature)
        ? { $case: "feature", value: FeatureTemplate.fromJSON(object.feature) }
        : isSet(object.planSubItem)
        ? { $case: "planSubItem", value: PlanSubItemTemplate.fromJSON(object.planSubItem) }
        : isSet(object.plan_sub_item)
        ? { $case: "planSubItem", value: PlanSubItemTemplate.fromJSON(object.plan_sub_item) }
        : isSet(object.customDocument)
        ? { $case: "customDocument", value: CustomDocumentTemplate.fromJSON(object.customDocument) }
        : isSet(object.custom_document)
        ? { $case: "customDocument", value: CustomDocumentTemplate.fromJSON(object.custom_document) }
        : isSet(object.codingAssistant)
        ? { $case: "codingAssistant", value: CodingAssistantTemplate.fromJSON(object.codingAssistant) }
        : isSet(object.coding_assistant)
        ? { $case: "codingAssistant", value: CodingAssistantTemplate.fromJSON(object.coding_assistant) }
        : undefined,
    };
  },

  toJSON(message: DocumentTemplate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.meta !== undefined) {
      obj.meta = TemplateMeta.toJSON(message.meta);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.type?.$case === "prd") {
      obj.prd = PrdTemplate.toJSON(message.type.value);
    } else if (message.type?.$case === "projectPlan") {
      obj.projectPlan = ProjectPlanTemplate.toJSON(message.type.value);
    } else if (message.type?.$case === "feature") {
      obj.feature = FeatureTemplate.toJSON(message.type.value);
    } else if (message.type?.$case === "planSubItem") {
      obj.planSubItem = PlanSubItemTemplate.toJSON(message.type.value);
    } else if (message.type?.$case === "customDocument") {
      obj.customDocument = CustomDocumentTemplate.toJSON(message.type.value);
    } else if (message.type?.$case === "codingAssistant") {
      obj.codingAssistant = CodingAssistantTemplate.toJSON(message.type.value);
    }
    return obj;
  },

  create(base?: DeepPartial<DocumentTemplate>): DocumentTemplate {
    return DocumentTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DocumentTemplate>): DocumentTemplate {
    const message = createBaseDocumentTemplate();
    message.id = object.id ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? TemplateMeta.fromPartial(object.meta)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    switch (object.type?.$case) {
      case "prd": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "prd", value: PrdTemplate.fromPartial(object.type.value) };
        }
        break;
      }
      case "projectPlan": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "projectPlan", value: ProjectPlanTemplate.fromPartial(object.type.value) };
        }
        break;
      }
      case "feature": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "feature", value: FeatureTemplate.fromPartial(object.type.value) };
        }
        break;
      }
      case "planSubItem": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "planSubItem", value: PlanSubItemTemplate.fromPartial(object.type.value) };
        }
        break;
      }
      case "customDocument": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "customDocument", value: CustomDocumentTemplate.fromPartial(object.type.value) };
        }
        break;
      }
      case "codingAssistant": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "codingAssistant", value: CodingAssistantTemplate.fromPartial(object.type.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseTemplateMeta(): TemplateMeta {
  return { name: "", description: "", status: 0, categories: [], partOfDraft: false };
}

export const TemplateMeta: MessageFns<TemplateMeta> = {
  encode(message: TemplateMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    for (const v of message.categories) {
      writer.uint32(34).string(v!);
    }
    if (message.partOfDraft !== false) {
      writer.uint32(40).bool(message.partOfDraft);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TemplateMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTemplateMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.categories.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.partOfDraft = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TemplateMeta {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      status: isSet(object.status) ? templateStatusFromJSON(object.status) : 0,
      categories: globalThis.Array.isArray(object?.categories)
        ? object.categories.map((e: any) => globalThis.String(e))
        : [],
      partOfDraft: isSet(object.partOfDraft)
        ? globalThis.Boolean(object.partOfDraft)
        : isSet(object.part_of_draft)
        ? globalThis.Boolean(object.part_of_draft)
        : false,
    };
  },

  toJSON(message: TemplateMeta): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.status !== 0) {
      obj.status = templateStatusToJSON(message.status);
    }
    if (message.categories?.length) {
      obj.categories = message.categories;
    }
    if (message.partOfDraft !== false) {
      obj.partOfDraft = message.partOfDraft;
    }
    return obj;
  },

  create(base?: DeepPartial<TemplateMeta>): TemplateMeta {
    return TemplateMeta.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TemplateMeta>): TemplateMeta {
    const message = createBaseTemplateMeta();
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.status = object.status ?? 0;
    message.categories = object.categories?.map((e) => e) || [];
    message.partOfDraft = object.partOfDraft ?? false;
    return message;
  },
};

function createBaseFeatureTemplate(): FeatureTemplate {
  return {
    initialInput: undefined,
    initialCritiqueLoops: 0,
    critiqueLoops: 0,
    chatPrompt: undefined,
    generationPlan: undefined,
    generationPrompt: undefined,
    critiquePrompt: undefined,
    confirmationPrompt: undefined,
    descriptionPrompt: undefined,
  };
}

export const FeatureTemplate: MessageFns<FeatureTemplate> = {
  encode(message: FeatureTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.initialInput !== undefined) {
      TemplateInitialInput.encode(message.initialInput, writer.uint32(18).fork()).join();
    }
    if (message.initialCritiqueLoops !== 0) {
      writer.uint32(24).int32(message.initialCritiqueLoops);
    }
    if (message.critiqueLoops !== 0) {
      writer.uint32(32).int32(message.critiqueLoops);
    }
    if (message.chatPrompt !== undefined) {
      PromptTemplate.encode(message.chatPrompt, writer.uint32(42).fork()).join();
    }
    if (message.generationPlan !== undefined) {
      GenerationPlan.encode(message.generationPlan, writer.uint32(82).fork()).join();
    }
    if (message.generationPrompt !== undefined) {
      PromptTemplate.encode(message.generationPrompt, writer.uint32(50).fork()).join();
    }
    if (message.critiquePrompt !== undefined) {
      PromptTemplate.encode(message.critiquePrompt, writer.uint32(58).fork()).join();
    }
    if (message.confirmationPrompt !== undefined) {
      PromptTemplate.encode(message.confirmationPrompt, writer.uint32(66).fork()).join();
    }
    if (message.descriptionPrompt !== undefined) {
      PromptTemplate.encode(message.descriptionPrompt, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FeatureTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFeatureTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.initialInput = TemplateInitialInput.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.initialCritiqueLoops = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.critiqueLoops = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.chatPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.generationPlan = GenerationPlan.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.generationPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.critiquePrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.confirmationPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.descriptionPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FeatureTemplate {
    return {
      initialInput: isSet(object.initialInput)
        ? TemplateInitialInput.fromJSON(object.initialInput)
        : isSet(object.initial_input)
        ? TemplateInitialInput.fromJSON(object.initial_input)
        : undefined,
      initialCritiqueLoops: isSet(object.initialCritiqueLoops)
        ? globalThis.Number(object.initialCritiqueLoops)
        : isSet(object.initial_critique_loops)
        ? globalThis.Number(object.initial_critique_loops)
        : 0,
      critiqueLoops: isSet(object.critiqueLoops)
        ? globalThis.Number(object.critiqueLoops)
        : isSet(object.critique_loops)
        ? globalThis.Number(object.critique_loops)
        : 0,
      chatPrompt: isSet(object.chatPrompt)
        ? PromptTemplate.fromJSON(object.chatPrompt)
        : isSet(object.chat_prompt)
        ? PromptTemplate.fromJSON(object.chat_prompt)
        : undefined,
      generationPlan: isSet(object.generationPlan)
        ? GenerationPlan.fromJSON(object.generationPlan)
        : isSet(object.generation_plan)
        ? GenerationPlan.fromJSON(object.generation_plan)
        : undefined,
      generationPrompt: isSet(object.generationPrompt)
        ? PromptTemplate.fromJSON(object.generationPrompt)
        : isSet(object.generation_prompt)
        ? PromptTemplate.fromJSON(object.generation_prompt)
        : undefined,
      critiquePrompt: isSet(object.critiquePrompt)
        ? PromptTemplate.fromJSON(object.critiquePrompt)
        : isSet(object.critique_prompt)
        ? PromptTemplate.fromJSON(object.critique_prompt)
        : undefined,
      confirmationPrompt: isSet(object.confirmationPrompt)
        ? PromptTemplate.fromJSON(object.confirmationPrompt)
        : isSet(object.confirmation_prompt)
        ? PromptTemplate.fromJSON(object.confirmation_prompt)
        : undefined,
      descriptionPrompt: isSet(object.descriptionPrompt)
        ? PromptTemplate.fromJSON(object.descriptionPrompt)
        : isSet(object.description_prompt)
        ? PromptTemplate.fromJSON(object.description_prompt)
        : undefined,
    };
  },

  toJSON(message: FeatureTemplate): unknown {
    const obj: any = {};
    if (message.initialInput !== undefined) {
      obj.initialInput = TemplateInitialInput.toJSON(message.initialInput);
    }
    if (message.initialCritiqueLoops !== 0) {
      obj.initialCritiqueLoops = Math.round(message.initialCritiqueLoops);
    }
    if (message.critiqueLoops !== 0) {
      obj.critiqueLoops = Math.round(message.critiqueLoops);
    }
    if (message.chatPrompt !== undefined) {
      obj.chatPrompt = PromptTemplate.toJSON(message.chatPrompt);
    }
    if (message.generationPlan !== undefined) {
      obj.generationPlan = GenerationPlan.toJSON(message.generationPlan);
    }
    if (message.generationPrompt !== undefined) {
      obj.generationPrompt = PromptTemplate.toJSON(message.generationPrompt);
    }
    if (message.critiquePrompt !== undefined) {
      obj.critiquePrompt = PromptTemplate.toJSON(message.critiquePrompt);
    }
    if (message.confirmationPrompt !== undefined) {
      obj.confirmationPrompt = PromptTemplate.toJSON(message.confirmationPrompt);
    }
    if (message.descriptionPrompt !== undefined) {
      obj.descriptionPrompt = PromptTemplate.toJSON(message.descriptionPrompt);
    }
    return obj;
  },

  create(base?: DeepPartial<FeatureTemplate>): FeatureTemplate {
    return FeatureTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FeatureTemplate>): FeatureTemplate {
    const message = createBaseFeatureTemplate();
    message.initialInput = (object.initialInput !== undefined && object.initialInput !== null)
      ? TemplateInitialInput.fromPartial(object.initialInput)
      : undefined;
    message.initialCritiqueLoops = object.initialCritiqueLoops ?? 0;
    message.critiqueLoops = object.critiqueLoops ?? 0;
    message.chatPrompt = (object.chatPrompt !== undefined && object.chatPrompt !== null)
      ? PromptTemplate.fromPartial(object.chatPrompt)
      : undefined;
    message.generationPlan = (object.generationPlan !== undefined && object.generationPlan !== null)
      ? GenerationPlan.fromPartial(object.generationPlan)
      : undefined;
    message.generationPrompt = (object.generationPrompt !== undefined && object.generationPrompt !== null)
      ? PromptTemplate.fromPartial(object.generationPrompt)
      : undefined;
    message.critiquePrompt = (object.critiquePrompt !== undefined && object.critiquePrompt !== null)
      ? PromptTemplate.fromPartial(object.critiquePrompt)
      : undefined;
    message.confirmationPrompt = (object.confirmationPrompt !== undefined && object.confirmationPrompt !== null)
      ? PromptTemplate.fromPartial(object.confirmationPrompt)
      : undefined;
    message.descriptionPrompt = (object.descriptionPrompt !== undefined && object.descriptionPrompt !== null)
      ? PromptTemplate.fromPartial(object.descriptionPrompt)
      : undefined;
    return message;
  },
};

function createBaseDocumentSection(): DocumentSection {
  return { name: "", description: "", formattingHints: "" };
}

export const DocumentSection: MessageFns<DocumentSection> = {
  encode(message: DocumentSection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.formattingHints !== "") {
      writer.uint32(26).string(message.formattingHints);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DocumentSection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDocumentSection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.formattingHints = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DocumentSection {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      formattingHints: isSet(object.formattingHints)
        ? globalThis.String(object.formattingHints)
        : isSet(object.formatting_hints)
        ? globalThis.String(object.formatting_hints)
        : "",
    };
  },

  toJSON(message: DocumentSection): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.formattingHints !== "") {
      obj.formattingHints = message.formattingHints;
    }
    return obj;
  },

  create(base?: DeepPartial<DocumentSection>): DocumentSection {
    return DocumentSection.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DocumentSection>): DocumentSection {
    const message = createBaseDocumentSection();
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.formattingHints = object.formattingHints ?? "";
    return message;
  },
};

function createBaseSummarySections(): SummarySections {
  return { sections: [], skip: false };
}

export const SummarySections: MessageFns<SummarySections> = {
  encode(message: SummarySections, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.sections) {
      DocumentSection.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.skip !== false) {
      writer.uint32(16).bool(message.skip);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SummarySections {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSummarySections();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sections.push(DocumentSection.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.skip = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SummarySections {
    return {
      sections: globalThis.Array.isArray(object?.sections)
        ? object.sections.map((e: any) => DocumentSection.fromJSON(e))
        : [],
      skip: isSet(object.skip) ? globalThis.Boolean(object.skip) : false,
    };
  },

  toJSON(message: SummarySections): unknown {
    const obj: any = {};
    if (message.sections?.length) {
      obj.sections = message.sections.map((e) => DocumentSection.toJSON(e));
    }
    if (message.skip !== false) {
      obj.skip = message.skip;
    }
    return obj;
  },

  create(base?: DeepPartial<SummarySections>): SummarySections {
    return SummarySections.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SummarySections>): SummarySections {
    const message = createBaseSummarySections();
    message.sections = object.sections?.map((e) => DocumentSection.fromPartial(e)) || [];
    message.skip = object.skip ?? false;
    return message;
  },
};

function createBaseFullDocumentSections(): FullDocumentSections {
  return { sections: [] };
}

export const FullDocumentSections: MessageFns<FullDocumentSections> = {
  encode(message: FullDocumentSections, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.sections) {
      DocumentSection.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FullDocumentSections {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFullDocumentSections();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sections.push(DocumentSection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FullDocumentSections {
    return {
      sections: globalThis.Array.isArray(object?.sections)
        ? object.sections.map((e: any) => DocumentSection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FullDocumentSections): unknown {
    const obj: any = {};
    if (message.sections?.length) {
      obj.sections = message.sections.map((e) => DocumentSection.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<FullDocumentSections>): FullDocumentSections {
    return FullDocumentSections.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FullDocumentSections>): FullDocumentSections {
    const message = createBaseFullDocumentSections();
    message.sections = object.sections?.map((e) => DocumentSection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGenerationPlan(): GenerationPlan {
  return { enabled: false, everyRun: false, prompt: undefined };
}

export const GenerationPlan: MessageFns<GenerationPlan> = {
  encode(message: GenerationPlan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    if (message.everyRun !== false) {
      writer.uint32(16).bool(message.everyRun);
    }
    if (message.prompt !== undefined) {
      PromptTemplate.encode(message.prompt, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerationPlan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerationPlan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.everyRun = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.prompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerationPlan {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      everyRun: isSet(object.everyRun)
        ? globalThis.Boolean(object.everyRun)
        : isSet(object.every_run)
        ? globalThis.Boolean(object.every_run)
        : false,
      prompt: isSet(object.prompt) ? PromptTemplate.fromJSON(object.prompt) : undefined,
    };
  },

  toJSON(message: GenerationPlan): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.everyRun !== false) {
      obj.everyRun = message.everyRun;
    }
    if (message.prompt !== undefined) {
      obj.prompt = PromptTemplate.toJSON(message.prompt);
    }
    return obj;
  },

  create(base?: DeepPartial<GenerationPlan>): GenerationPlan {
    return GenerationPlan.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GenerationPlan>): GenerationPlan {
    const message = createBaseGenerationPlan();
    message.enabled = object.enabled ?? false;
    message.everyRun = object.everyRun ?? false;
    message.prompt = (object.prompt !== undefined && object.prompt !== null)
      ? PromptTemplate.fromPartial(object.prompt)
      : undefined;
    return message;
  },
};

function createBasePrdTemplate(): PrdTemplate {
  return {
    initialInput: undefined,
    summarySections: undefined,
    fullSections: undefined,
    summaryChatPrompt: undefined,
    summaryConfirmationPrompt: undefined,
    confirmSummaryTitle: undefined,
    fullInitialPrompt: undefined,
    fullChatPrompt: undefined,
    fullConfirmationPrompt: undefined,
    writePlan: undefined,
    writePrompt: undefined,
    critiquePrompt: undefined,
    initialCritiqueLoops: 0,
    critiqueLoops: 0,
  };
}

export const PrdTemplate: MessageFns<PrdTemplate> = {
  encode(message: PrdTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.initialInput !== undefined) {
      TemplateInitialInput.encode(message.initialInput, writer.uint32(18).fork()).join();
    }
    if (message.summarySections !== undefined) {
      SummarySections.encode(message.summarySections, writer.uint32(26).fork()).join();
    }
    if (message.fullSections !== undefined) {
      FullDocumentSections.encode(message.fullSections, writer.uint32(34).fork()).join();
    }
    if (message.summaryChatPrompt !== undefined) {
      PromptTemplate.encode(message.summaryChatPrompt, writer.uint32(162).fork()).join();
    }
    if (message.summaryConfirmationPrompt !== undefined) {
      PromptTemplate.encode(message.summaryConfirmationPrompt, writer.uint32(170).fork()).join();
    }
    if (message.confirmSummaryTitle !== undefined) {
      writer.uint32(178).string(message.confirmSummaryTitle);
    }
    if (message.fullInitialPrompt !== undefined) {
      PromptTemplate.encode(message.fullInitialPrompt, writer.uint32(242).fork()).join();
    }
    if (message.fullChatPrompt !== undefined) {
      PromptTemplate.encode(message.fullChatPrompt, writer.uint32(250).fork()).join();
    }
    if (message.fullConfirmationPrompt !== undefined) {
      PromptTemplate.encode(message.fullConfirmationPrompt, writer.uint32(258).fork()).join();
    }
    if (message.writePlan !== undefined) {
      GenerationPlan.encode(message.writePlan, writer.uint32(354).fork()).join();
    }
    if (message.writePrompt !== undefined) {
      PromptTemplate.encode(message.writePrompt, writer.uint32(322).fork()).join();
    }
    if (message.critiquePrompt !== undefined) {
      PromptTemplate.encode(message.critiquePrompt, writer.uint32(330).fork()).join();
    }
    if (message.initialCritiqueLoops !== 0) {
      writer.uint32(336).int32(message.initialCritiqueLoops);
    }
    if (message.critiqueLoops !== 0) {
      writer.uint32(344).int32(message.critiqueLoops);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PrdTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrdTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.initialInput = TemplateInitialInput.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.summarySections = SummarySections.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fullSections = FullDocumentSections.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.summaryChatPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.summaryConfirmationPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.confirmSummaryTitle = reader.string();
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.fullInitialPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.fullChatPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.fullConfirmationPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 44: {
          if (tag !== 354) {
            break;
          }

          message.writePlan = GenerationPlan.decode(reader, reader.uint32());
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.writePrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.critiquePrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 42: {
          if (tag !== 336) {
            break;
          }

          message.initialCritiqueLoops = reader.int32();
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.critiqueLoops = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrdTemplate {
    return {
      initialInput: isSet(object.initialInput)
        ? TemplateInitialInput.fromJSON(object.initialInput)
        : isSet(object.initial_input)
        ? TemplateInitialInput.fromJSON(object.initial_input)
        : undefined,
      summarySections: isSet(object.summarySections)
        ? SummarySections.fromJSON(object.summarySections)
        : isSet(object.summary_sections)
        ? SummarySections.fromJSON(object.summary_sections)
        : undefined,
      fullSections: isSet(object.fullSections)
        ? FullDocumentSections.fromJSON(object.fullSections)
        : isSet(object.full_sections)
        ? FullDocumentSections.fromJSON(object.full_sections)
        : undefined,
      summaryChatPrompt: isSet(object.summaryChatPrompt)
        ? PromptTemplate.fromJSON(object.summaryChatPrompt)
        : isSet(object.summary_chat_prompt)
        ? PromptTemplate.fromJSON(object.summary_chat_prompt)
        : undefined,
      summaryConfirmationPrompt: isSet(object.summaryConfirmationPrompt)
        ? PromptTemplate.fromJSON(object.summaryConfirmationPrompt)
        : isSet(object.summary_confirmation_prompt)
        ? PromptTemplate.fromJSON(object.summary_confirmation_prompt)
        : undefined,
      confirmSummaryTitle: isSet(object.confirmSummaryTitle)
        ? globalThis.String(object.confirmSummaryTitle)
        : isSet(object.confirm_summary_title)
        ? globalThis.String(object.confirm_summary_title)
        : undefined,
      fullInitialPrompt: isSet(object.fullInitialPrompt)
        ? PromptTemplate.fromJSON(object.fullInitialPrompt)
        : isSet(object.full_initial_prompt)
        ? PromptTemplate.fromJSON(object.full_initial_prompt)
        : undefined,
      fullChatPrompt: isSet(object.fullChatPrompt)
        ? PromptTemplate.fromJSON(object.fullChatPrompt)
        : isSet(object.full_chat_prompt)
        ? PromptTemplate.fromJSON(object.full_chat_prompt)
        : undefined,
      fullConfirmationPrompt: isSet(object.fullConfirmationPrompt)
        ? PromptTemplate.fromJSON(object.fullConfirmationPrompt)
        : isSet(object.full_confirmation_prompt)
        ? PromptTemplate.fromJSON(object.full_confirmation_prompt)
        : undefined,
      writePlan: isSet(object.writePlan)
        ? GenerationPlan.fromJSON(object.writePlan)
        : isSet(object.write_plan)
        ? GenerationPlan.fromJSON(object.write_plan)
        : undefined,
      writePrompt: isSet(object.writePrompt)
        ? PromptTemplate.fromJSON(object.writePrompt)
        : isSet(object.write_prompt)
        ? PromptTemplate.fromJSON(object.write_prompt)
        : undefined,
      critiquePrompt: isSet(object.critiquePrompt)
        ? PromptTemplate.fromJSON(object.critiquePrompt)
        : isSet(object.critique_prompt)
        ? PromptTemplate.fromJSON(object.critique_prompt)
        : undefined,
      initialCritiqueLoops: isSet(object.initialCritiqueLoops)
        ? globalThis.Number(object.initialCritiqueLoops)
        : isSet(object.initial_critique_loops)
        ? globalThis.Number(object.initial_critique_loops)
        : 0,
      critiqueLoops: isSet(object.critiqueLoops)
        ? globalThis.Number(object.critiqueLoops)
        : isSet(object.critique_loops)
        ? globalThis.Number(object.critique_loops)
        : 0,
    };
  },

  toJSON(message: PrdTemplate): unknown {
    const obj: any = {};
    if (message.initialInput !== undefined) {
      obj.initialInput = TemplateInitialInput.toJSON(message.initialInput);
    }
    if (message.summarySections !== undefined) {
      obj.summarySections = SummarySections.toJSON(message.summarySections);
    }
    if (message.fullSections !== undefined) {
      obj.fullSections = FullDocumentSections.toJSON(message.fullSections);
    }
    if (message.summaryChatPrompt !== undefined) {
      obj.summaryChatPrompt = PromptTemplate.toJSON(message.summaryChatPrompt);
    }
    if (message.summaryConfirmationPrompt !== undefined) {
      obj.summaryConfirmationPrompt = PromptTemplate.toJSON(message.summaryConfirmationPrompt);
    }
    if (message.confirmSummaryTitle !== undefined) {
      obj.confirmSummaryTitle = message.confirmSummaryTitle;
    }
    if (message.fullInitialPrompt !== undefined) {
      obj.fullInitialPrompt = PromptTemplate.toJSON(message.fullInitialPrompt);
    }
    if (message.fullChatPrompt !== undefined) {
      obj.fullChatPrompt = PromptTemplate.toJSON(message.fullChatPrompt);
    }
    if (message.fullConfirmationPrompt !== undefined) {
      obj.fullConfirmationPrompt = PromptTemplate.toJSON(message.fullConfirmationPrompt);
    }
    if (message.writePlan !== undefined) {
      obj.writePlan = GenerationPlan.toJSON(message.writePlan);
    }
    if (message.writePrompt !== undefined) {
      obj.writePrompt = PromptTemplate.toJSON(message.writePrompt);
    }
    if (message.critiquePrompt !== undefined) {
      obj.critiquePrompt = PromptTemplate.toJSON(message.critiquePrompt);
    }
    if (message.initialCritiqueLoops !== 0) {
      obj.initialCritiqueLoops = Math.round(message.initialCritiqueLoops);
    }
    if (message.critiqueLoops !== 0) {
      obj.critiqueLoops = Math.round(message.critiqueLoops);
    }
    return obj;
  },

  create(base?: DeepPartial<PrdTemplate>): PrdTemplate {
    return PrdTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PrdTemplate>): PrdTemplate {
    const message = createBasePrdTemplate();
    message.initialInput = (object.initialInput !== undefined && object.initialInput !== null)
      ? TemplateInitialInput.fromPartial(object.initialInput)
      : undefined;
    message.summarySections = (object.summarySections !== undefined && object.summarySections !== null)
      ? SummarySections.fromPartial(object.summarySections)
      : undefined;
    message.fullSections = (object.fullSections !== undefined && object.fullSections !== null)
      ? FullDocumentSections.fromPartial(object.fullSections)
      : undefined;
    message.summaryChatPrompt = (object.summaryChatPrompt !== undefined && object.summaryChatPrompt !== null)
      ? PromptTemplate.fromPartial(object.summaryChatPrompt)
      : undefined;
    message.summaryConfirmationPrompt =
      (object.summaryConfirmationPrompt !== undefined && object.summaryConfirmationPrompt !== null)
        ? PromptTemplate.fromPartial(object.summaryConfirmationPrompt)
        : undefined;
    message.confirmSummaryTitle = object.confirmSummaryTitle ?? undefined;
    message.fullInitialPrompt = (object.fullInitialPrompt !== undefined && object.fullInitialPrompt !== null)
      ? PromptTemplate.fromPartial(object.fullInitialPrompt)
      : undefined;
    message.fullChatPrompt = (object.fullChatPrompt !== undefined && object.fullChatPrompt !== null)
      ? PromptTemplate.fromPartial(object.fullChatPrompt)
      : undefined;
    message.fullConfirmationPrompt =
      (object.fullConfirmationPrompt !== undefined && object.fullConfirmationPrompt !== null)
        ? PromptTemplate.fromPartial(object.fullConfirmationPrompt)
        : undefined;
    message.writePlan = (object.writePlan !== undefined && object.writePlan !== null)
      ? GenerationPlan.fromPartial(object.writePlan)
      : undefined;
    message.writePrompt = (object.writePrompt !== undefined && object.writePrompt !== null)
      ? PromptTemplate.fromPartial(object.writePrompt)
      : undefined;
    message.critiquePrompt = (object.critiquePrompt !== undefined && object.critiquePrompt !== null)
      ? PromptTemplate.fromPartial(object.critiquePrompt)
      : undefined;
    message.initialCritiqueLoops = object.initialCritiqueLoops ?? 0;
    message.critiqueLoops = object.critiqueLoops ?? 0;
    return message;
  },
};

function createBasePlanSubItemTemplate(): PlanSubItemTemplate {
  return { chatPrompt: undefined, confirmationPrompt: undefined, descriptionPrompt: undefined };
}

export const PlanSubItemTemplate: MessageFns<PlanSubItemTemplate> = {
  encode(message: PlanSubItemTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatPrompt !== undefined) {
      PromptTemplate.encode(message.chatPrompt, writer.uint32(18).fork()).join();
    }
    if (message.confirmationPrompt !== undefined) {
      PromptTemplate.encode(message.confirmationPrompt, writer.uint32(26).fork()).join();
    }
    if (message.descriptionPrompt !== undefined) {
      PromptTemplate.encode(message.descriptionPrompt, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanSubItemTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanSubItemTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chatPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.confirmationPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.descriptionPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanSubItemTemplate {
    return {
      chatPrompt: isSet(object.chatPrompt)
        ? PromptTemplate.fromJSON(object.chatPrompt)
        : isSet(object.chat_prompt)
        ? PromptTemplate.fromJSON(object.chat_prompt)
        : undefined,
      confirmationPrompt: isSet(object.confirmationPrompt)
        ? PromptTemplate.fromJSON(object.confirmationPrompt)
        : isSet(object.confirmation_prompt)
        ? PromptTemplate.fromJSON(object.confirmation_prompt)
        : undefined,
      descriptionPrompt: isSet(object.descriptionPrompt)
        ? PromptTemplate.fromJSON(object.descriptionPrompt)
        : isSet(object.description_prompt)
        ? PromptTemplate.fromJSON(object.description_prompt)
        : undefined,
    };
  },

  toJSON(message: PlanSubItemTemplate): unknown {
    const obj: any = {};
    if (message.chatPrompt !== undefined) {
      obj.chatPrompt = PromptTemplate.toJSON(message.chatPrompt);
    }
    if (message.confirmationPrompt !== undefined) {
      obj.confirmationPrompt = PromptTemplate.toJSON(message.confirmationPrompt);
    }
    if (message.descriptionPrompt !== undefined) {
      obj.descriptionPrompt = PromptTemplate.toJSON(message.descriptionPrompt);
    }
    return obj;
  },

  create(base?: DeepPartial<PlanSubItemTemplate>): PlanSubItemTemplate {
    return PlanSubItemTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PlanSubItemTemplate>): PlanSubItemTemplate {
    const message = createBasePlanSubItemTemplate();
    message.chatPrompt = (object.chatPrompt !== undefined && object.chatPrompt !== null)
      ? PromptTemplate.fromPartial(object.chatPrompt)
      : undefined;
    message.confirmationPrompt = (object.confirmationPrompt !== undefined && object.confirmationPrompt !== null)
      ? PromptTemplate.fromPartial(object.confirmationPrompt)
      : undefined;
    message.descriptionPrompt = (object.descriptionPrompt !== undefined && object.descriptionPrompt !== null)
      ? PromptTemplate.fromPartial(object.descriptionPrompt)
      : undefined;
    return message;
  },
};

function createBaseProjectPlanTemplate(): ProjectPlanTemplate {
  return {
    initialCritiqueLoops: 0,
    critiqueLoops: 0,
    chatPrompt: undefined,
    generationPlan: undefined,
    generationPrompt: undefined,
    critiquePrompt: undefined,
    confirmationPrompt: undefined,
  };
}

export const ProjectPlanTemplate: MessageFns<ProjectPlanTemplate> = {
  encode(message: ProjectPlanTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.initialCritiqueLoops !== 0) {
      writer.uint32(16).int32(message.initialCritiqueLoops);
    }
    if (message.critiqueLoops !== 0) {
      writer.uint32(24).int32(message.critiqueLoops);
    }
    if (message.chatPrompt !== undefined) {
      PromptTemplate.encode(message.chatPrompt, writer.uint32(34).fork()).join();
    }
    if (message.generationPlan !== undefined) {
      GenerationPlan.encode(message.generationPlan, writer.uint32(66).fork()).join();
    }
    if (message.generationPrompt !== undefined) {
      PromptTemplate.encode(message.generationPrompt, writer.uint32(42).fork()).join();
    }
    if (message.critiquePrompt !== undefined) {
      PromptTemplate.encode(message.critiquePrompt, writer.uint32(50).fork()).join();
    }
    if (message.confirmationPrompt !== undefined) {
      PromptTemplate.encode(message.confirmationPrompt, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectPlanTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectPlanTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.initialCritiqueLoops = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.critiqueLoops = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.chatPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.generationPlan = GenerationPlan.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.generationPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.critiquePrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.confirmationPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectPlanTemplate {
    return {
      initialCritiqueLoops: isSet(object.initialCritiqueLoops)
        ? globalThis.Number(object.initialCritiqueLoops)
        : isSet(object.initial_critique_loops)
        ? globalThis.Number(object.initial_critique_loops)
        : 0,
      critiqueLoops: isSet(object.critiqueLoops)
        ? globalThis.Number(object.critiqueLoops)
        : isSet(object.critique_loops)
        ? globalThis.Number(object.critique_loops)
        : 0,
      chatPrompt: isSet(object.chatPrompt)
        ? PromptTemplate.fromJSON(object.chatPrompt)
        : isSet(object.chat_prompt)
        ? PromptTemplate.fromJSON(object.chat_prompt)
        : undefined,
      generationPlan: isSet(object.generationPlan)
        ? GenerationPlan.fromJSON(object.generationPlan)
        : isSet(object.generation_plan)
        ? GenerationPlan.fromJSON(object.generation_plan)
        : undefined,
      generationPrompt: isSet(object.generationPrompt)
        ? PromptTemplate.fromJSON(object.generationPrompt)
        : isSet(object.generation_prompt)
        ? PromptTemplate.fromJSON(object.generation_prompt)
        : undefined,
      critiquePrompt: isSet(object.critiquePrompt)
        ? PromptTemplate.fromJSON(object.critiquePrompt)
        : isSet(object.critique_prompt)
        ? PromptTemplate.fromJSON(object.critique_prompt)
        : undefined,
      confirmationPrompt: isSet(object.confirmationPrompt)
        ? PromptTemplate.fromJSON(object.confirmationPrompt)
        : isSet(object.confirmation_prompt)
        ? PromptTemplate.fromJSON(object.confirmation_prompt)
        : undefined,
    };
  },

  toJSON(message: ProjectPlanTemplate): unknown {
    const obj: any = {};
    if (message.initialCritiqueLoops !== 0) {
      obj.initialCritiqueLoops = Math.round(message.initialCritiqueLoops);
    }
    if (message.critiqueLoops !== 0) {
      obj.critiqueLoops = Math.round(message.critiqueLoops);
    }
    if (message.chatPrompt !== undefined) {
      obj.chatPrompt = PromptTemplate.toJSON(message.chatPrompt);
    }
    if (message.generationPlan !== undefined) {
      obj.generationPlan = GenerationPlan.toJSON(message.generationPlan);
    }
    if (message.generationPrompt !== undefined) {
      obj.generationPrompt = PromptTemplate.toJSON(message.generationPrompt);
    }
    if (message.critiquePrompt !== undefined) {
      obj.critiquePrompt = PromptTemplate.toJSON(message.critiquePrompt);
    }
    if (message.confirmationPrompt !== undefined) {
      obj.confirmationPrompt = PromptTemplate.toJSON(message.confirmationPrompt);
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectPlanTemplate>): ProjectPlanTemplate {
    return ProjectPlanTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectPlanTemplate>): ProjectPlanTemplate {
    const message = createBaseProjectPlanTemplate();
    message.initialCritiqueLoops = object.initialCritiqueLoops ?? 0;
    message.critiqueLoops = object.critiqueLoops ?? 0;
    message.chatPrompt = (object.chatPrompt !== undefined && object.chatPrompt !== null)
      ? PromptTemplate.fromPartial(object.chatPrompt)
      : undefined;
    message.generationPlan = (object.generationPlan !== undefined && object.generationPlan !== null)
      ? GenerationPlan.fromPartial(object.generationPlan)
      : undefined;
    message.generationPrompt = (object.generationPrompt !== undefined && object.generationPrompt !== null)
      ? PromptTemplate.fromPartial(object.generationPrompt)
      : undefined;
    message.critiquePrompt = (object.critiquePrompt !== undefined && object.critiquePrompt !== null)
      ? PromptTemplate.fromPartial(object.critiquePrompt)
      : undefined;
    message.confirmationPrompt = (object.confirmationPrompt !== undefined && object.confirmationPrompt !== null)
      ? PromptTemplate.fromPartial(object.confirmationPrompt)
      : undefined;
    return message;
  },
};

function createBaseSuggestionsTemplate(): SuggestionsTemplate {
  return { id: "", meta: undefined, details: undefined, createdAt: undefined, updatedAt: undefined };
}

export const SuggestionsTemplate: MessageFns<SuggestionsTemplate> = {
  encode(message: SuggestionsTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.meta !== undefined) {
      TemplateMeta.encode(message.meta, writer.uint32(18).fork()).join();
    }
    if (message.details !== undefined) {
      SuggestionsTemplateDetails.encode(message.details, writer.uint32(26).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SuggestionsTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuggestionsTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.meta = TemplateMeta.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.details = SuggestionsTemplateDetails.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SuggestionsTemplate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      meta: isSet(object.meta) ? TemplateMeta.fromJSON(object.meta) : undefined,
      details: isSet(object.details) ? SuggestionsTemplateDetails.fromJSON(object.details) : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: SuggestionsTemplate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.meta !== undefined) {
      obj.meta = TemplateMeta.toJSON(message.meta);
    }
    if (message.details !== undefined) {
      obj.details = SuggestionsTemplateDetails.toJSON(message.details);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<SuggestionsTemplate>): SuggestionsTemplate {
    return SuggestionsTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SuggestionsTemplate>): SuggestionsTemplate {
    const message = createBaseSuggestionsTemplate();
    message.id = object.id ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? TemplateMeta.fromPartial(object.meta)
      : undefined;
    message.details = (object.details !== undefined && object.details !== null)
      ? SuggestionsTemplateDetails.fromPartial(object.details)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseSuggestionsTemplateDetails(): SuggestionsTemplateDetails {
  return { acceptSuggestionsPrompt: undefined, responseSuggestionsPrompt: undefined };
}

export const SuggestionsTemplateDetails: MessageFns<SuggestionsTemplateDetails> = {
  encode(message: SuggestionsTemplateDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.acceptSuggestionsPrompt !== undefined) {
      PromptTemplate.encode(message.acceptSuggestionsPrompt, writer.uint32(18).fork()).join();
    }
    if (message.responseSuggestionsPrompt !== undefined) {
      PromptTemplate.encode(message.responseSuggestionsPrompt, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SuggestionsTemplateDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuggestionsTemplateDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.acceptSuggestionsPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.responseSuggestionsPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SuggestionsTemplateDetails {
    return {
      acceptSuggestionsPrompt: isSet(object.acceptSuggestionsPrompt)
        ? PromptTemplate.fromJSON(object.acceptSuggestionsPrompt)
        : isSet(object.accept_suggestions_prompt)
        ? PromptTemplate.fromJSON(object.accept_suggestions_prompt)
        : undefined,
      responseSuggestionsPrompt: isSet(object.responseSuggestionsPrompt)
        ? PromptTemplate.fromJSON(object.responseSuggestionsPrompt)
        : isSet(object.response_suggestions_prompt)
        ? PromptTemplate.fromJSON(object.response_suggestions_prompt)
        : undefined,
    };
  },

  toJSON(message: SuggestionsTemplateDetails): unknown {
    const obj: any = {};
    if (message.acceptSuggestionsPrompt !== undefined) {
      obj.acceptSuggestionsPrompt = PromptTemplate.toJSON(message.acceptSuggestionsPrompt);
    }
    if (message.responseSuggestionsPrompt !== undefined) {
      obj.responseSuggestionsPrompt = PromptTemplate.toJSON(message.responseSuggestionsPrompt);
    }
    return obj;
  },

  create(base?: DeepPartial<SuggestionsTemplateDetails>): SuggestionsTemplateDetails {
    return SuggestionsTemplateDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SuggestionsTemplateDetails>): SuggestionsTemplateDetails {
    const message = createBaseSuggestionsTemplateDetails();
    message.acceptSuggestionsPrompt =
      (object.acceptSuggestionsPrompt !== undefined && object.acceptSuggestionsPrompt !== null)
        ? PromptTemplate.fromPartial(object.acceptSuggestionsPrompt)
        : undefined;
    message.responseSuggestionsPrompt =
      (object.responseSuggestionsPrompt !== undefined && object.responseSuggestionsPrompt !== null)
        ? PromptTemplate.fromPartial(object.responseSuggestionsPrompt)
        : undefined;
    return message;
  },
};

function createBaseProjectTemplateInfo(): ProjectTemplateInfo {
  return { templateId: "", suggestionsTemplateId: undefined };
}

export const ProjectTemplateInfo: MessageFns<ProjectTemplateInfo> = {
  encode(message: ProjectTemplateInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.templateId !== "") {
      writer.uint32(10).string(message.templateId);
    }
    if (message.suggestionsTemplateId !== undefined) {
      writer.uint32(18).string(message.suggestionsTemplateId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectTemplateInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectTemplateInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.templateId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.suggestionsTemplateId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectTemplateInfo {
    return {
      templateId: isSet(object.templateId)
        ? globalThis.String(object.templateId)
        : isSet(object.template_id)
        ? globalThis.String(object.template_id)
        : "",
      suggestionsTemplateId: isSet(object.suggestionsTemplateId)
        ? globalThis.String(object.suggestionsTemplateId)
        : isSet(object.suggestions_template_id)
        ? globalThis.String(object.suggestions_template_id)
        : undefined,
    };
  },

  toJSON(message: ProjectTemplateInfo): unknown {
    const obj: any = {};
    if (message.templateId !== "") {
      obj.templateId = message.templateId;
    }
    if (message.suggestionsTemplateId !== undefined) {
      obj.suggestionsTemplateId = message.suggestionsTemplateId;
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectTemplateInfo>): ProjectTemplateInfo {
    return ProjectTemplateInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectTemplateInfo>): ProjectTemplateInfo {
    const message = createBaseProjectTemplateInfo();
    message.templateId = object.templateId ?? "";
    message.suggestionsTemplateId = object.suggestionsTemplateId ?? undefined;
    return message;
  },
};

function createBaseProjectTemplate(): ProjectTemplate {
  return { id: "", meta: undefined, details: undefined, createdAt: undefined, updatedAt: undefined };
}

export const ProjectTemplate: MessageFns<ProjectTemplate> = {
  encode(message: ProjectTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.meta !== undefined) {
      TemplateMeta.encode(message.meta, writer.uint32(18).fork()).join();
    }
    if (message.details !== undefined) {
      ProjectTemplateDetails.encode(message.details, writer.uint32(26).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.meta = TemplateMeta.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.details = ProjectTemplateDetails.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectTemplate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      meta: isSet(object.meta) ? TemplateMeta.fromJSON(object.meta) : undefined,
      details: isSet(object.details) ? ProjectTemplateDetails.fromJSON(object.details) : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: ProjectTemplate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.meta !== undefined) {
      obj.meta = TemplateMeta.toJSON(message.meta);
    }
    if (message.details !== undefined) {
      obj.details = ProjectTemplateDetails.toJSON(message.details);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectTemplate>): ProjectTemplate {
    return ProjectTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectTemplate>): ProjectTemplate {
    const message = createBaseProjectTemplate();
    message.id = object.id ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? TemplateMeta.fromPartial(object.meta)
      : undefined;
    message.details = (object.details !== undefined && object.details !== null)
      ? ProjectTemplateDetails.fromPartial(object.details)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseProjectTabLayout(): ProjectTabLayout {
  return { enabled: false, promptPrefixes: undefined };
}

export const ProjectTabLayout: MessageFns<ProjectTabLayout> = {
  encode(message: ProjectTabLayout, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    if (message.promptPrefixes !== undefined) {
      ProjectTabLayout_PromptPrefixes.encode(message.promptPrefixes, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectTabLayout {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectTabLayout();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.promptPrefixes = ProjectTabLayout_PromptPrefixes.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectTabLayout {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      promptPrefixes: isSet(object.promptPrefixes)
        ? ProjectTabLayout_PromptPrefixes.fromJSON(object.promptPrefixes)
        : isSet(object.prompt_prefixes)
        ? ProjectTabLayout_PromptPrefixes.fromJSON(object.prompt_prefixes)
        : undefined,
    };
  },

  toJSON(message: ProjectTabLayout): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.promptPrefixes !== undefined) {
      obj.promptPrefixes = ProjectTabLayout_PromptPrefixes.toJSON(message.promptPrefixes);
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectTabLayout>): ProjectTabLayout {
    return ProjectTabLayout.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectTabLayout>): ProjectTabLayout {
    const message = createBaseProjectTabLayout();
    message.enabled = object.enabled ?? false;
    message.promptPrefixes = (object.promptPrefixes !== undefined && object.promptPrefixes !== null)
      ? ProjectTabLayout_PromptPrefixes.fromPartial(object.promptPrefixes)
      : undefined;
    return message;
  },
};

function createBaseProjectTabLayout_PromptPrefixes(): ProjectTabLayout_PromptPrefixes {
  return {
    productAgent: "",
    devAgent: "",
    taskPromptAgent: "",
    productBriefAgent: "",
    techBriefAgent: "",
    userStoriesAgent: "",
    userStoryTasksAgent: "",
    projectTasksAgent: "",
    discoveryAgent: "",
    discoveryBriefAgent: "",
    riceScoreAgent: "",
  };
}

export const ProjectTabLayout_PromptPrefixes: MessageFns<ProjectTabLayout_PromptPrefixes> = {
  encode(message: ProjectTabLayout_PromptPrefixes, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.productAgent !== "") {
      writer.uint32(10).string(message.productAgent);
    }
    if (message.devAgent !== "") {
      writer.uint32(18).string(message.devAgent);
    }
    if (message.taskPromptAgent !== "") {
      writer.uint32(26).string(message.taskPromptAgent);
    }
    if (message.productBriefAgent !== "") {
      writer.uint32(34).string(message.productBriefAgent);
    }
    if (message.techBriefAgent !== "") {
      writer.uint32(42).string(message.techBriefAgent);
    }
    if (message.userStoriesAgent !== "") {
      writer.uint32(50).string(message.userStoriesAgent);
    }
    if (message.userStoryTasksAgent !== "") {
      writer.uint32(58).string(message.userStoryTasksAgent);
    }
    if (message.projectTasksAgent !== "") {
      writer.uint32(66).string(message.projectTasksAgent);
    }
    if (message.discoveryAgent !== "") {
      writer.uint32(74).string(message.discoveryAgent);
    }
    if (message.discoveryBriefAgent !== "") {
      writer.uint32(82).string(message.discoveryBriefAgent);
    }
    if (message.riceScoreAgent !== "") {
      writer.uint32(90).string(message.riceScoreAgent);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectTabLayout_PromptPrefixes {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectTabLayout_PromptPrefixes();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.productAgent = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.devAgent = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.taskPromptAgent = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.productBriefAgent = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.techBriefAgent = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.userStoriesAgent = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.userStoryTasksAgent = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.projectTasksAgent = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.discoveryAgent = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.discoveryBriefAgent = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.riceScoreAgent = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectTabLayout_PromptPrefixes {
    return {
      productAgent: isSet(object.productAgent)
        ? globalThis.String(object.productAgent)
        : isSet(object.product_agent)
        ? globalThis.String(object.product_agent)
        : "",
      devAgent: isSet(object.devAgent)
        ? globalThis.String(object.devAgent)
        : isSet(object.dev_agent)
        ? globalThis.String(object.dev_agent)
        : "",
      taskPromptAgent: isSet(object.taskPromptAgent)
        ? globalThis.String(object.taskPromptAgent)
        : isSet(object.task_prompt_agent)
        ? globalThis.String(object.task_prompt_agent)
        : "",
      productBriefAgent: isSet(object.productBriefAgent)
        ? globalThis.String(object.productBriefAgent)
        : isSet(object.product_brief_agent)
        ? globalThis.String(object.product_brief_agent)
        : "",
      techBriefAgent: isSet(object.techBriefAgent)
        ? globalThis.String(object.techBriefAgent)
        : isSet(object.tech_brief_agent)
        ? globalThis.String(object.tech_brief_agent)
        : "",
      userStoriesAgent: isSet(object.userStoriesAgent)
        ? globalThis.String(object.userStoriesAgent)
        : isSet(object.user_stories_agent)
        ? globalThis.String(object.user_stories_agent)
        : "",
      userStoryTasksAgent: isSet(object.userStoryTasksAgent)
        ? globalThis.String(object.userStoryTasksAgent)
        : isSet(object.user_story_tasks_agent)
        ? globalThis.String(object.user_story_tasks_agent)
        : "",
      projectTasksAgent: isSet(object.projectTasksAgent)
        ? globalThis.String(object.projectTasksAgent)
        : isSet(object.project_tasks_agent)
        ? globalThis.String(object.project_tasks_agent)
        : "",
      discoveryAgent: isSet(object.discoveryAgent)
        ? globalThis.String(object.discoveryAgent)
        : isSet(object.discovery_agent)
        ? globalThis.String(object.discovery_agent)
        : "",
      discoveryBriefAgent: isSet(object.discoveryBriefAgent)
        ? globalThis.String(object.discoveryBriefAgent)
        : isSet(object.discovery_brief_agent)
        ? globalThis.String(object.discovery_brief_agent)
        : "",
      riceScoreAgent: isSet(object.riceScoreAgent)
        ? globalThis.String(object.riceScoreAgent)
        : isSet(object.rice_score_agent)
        ? globalThis.String(object.rice_score_agent)
        : "",
    };
  },

  toJSON(message: ProjectTabLayout_PromptPrefixes): unknown {
    const obj: any = {};
    if (message.productAgent !== "") {
      obj.productAgent = message.productAgent;
    }
    if (message.devAgent !== "") {
      obj.devAgent = message.devAgent;
    }
    if (message.taskPromptAgent !== "") {
      obj.taskPromptAgent = message.taskPromptAgent;
    }
    if (message.productBriefAgent !== "") {
      obj.productBriefAgent = message.productBriefAgent;
    }
    if (message.techBriefAgent !== "") {
      obj.techBriefAgent = message.techBriefAgent;
    }
    if (message.userStoriesAgent !== "") {
      obj.userStoriesAgent = message.userStoriesAgent;
    }
    if (message.userStoryTasksAgent !== "") {
      obj.userStoryTasksAgent = message.userStoryTasksAgent;
    }
    if (message.projectTasksAgent !== "") {
      obj.projectTasksAgent = message.projectTasksAgent;
    }
    if (message.discoveryAgent !== "") {
      obj.discoveryAgent = message.discoveryAgent;
    }
    if (message.discoveryBriefAgent !== "") {
      obj.discoveryBriefAgent = message.discoveryBriefAgent;
    }
    if (message.riceScoreAgent !== "") {
      obj.riceScoreAgent = message.riceScoreAgent;
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectTabLayout_PromptPrefixes>): ProjectTabLayout_PromptPrefixes {
    return ProjectTabLayout_PromptPrefixes.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectTabLayout_PromptPrefixes>): ProjectTabLayout_PromptPrefixes {
    const message = createBaseProjectTabLayout_PromptPrefixes();
    message.productAgent = object.productAgent ?? "";
    message.devAgent = object.devAgent ?? "";
    message.taskPromptAgent = object.taskPromptAgent ?? "";
    message.productBriefAgent = object.productBriefAgent ?? "";
    message.techBriefAgent = object.techBriefAgent ?? "";
    message.userStoriesAgent = object.userStoriesAgent ?? "";
    message.userStoryTasksAgent = object.userStoryTasksAgent ?? "";
    message.projectTasksAgent = object.projectTasksAgent ?? "";
    message.discoveryAgent = object.discoveryAgent ?? "";
    message.discoveryBriefAgent = object.discoveryBriefAgent ?? "";
    message.riceScoreAgent = object.riceScoreAgent ?? "";
    return message;
  },
};

function createBaseProjectTemplateDetails(): ProjectTemplateDetails {
  return {
    requirements: undefined,
    plan: undefined,
    planItem: undefined,
    planSubItem: undefined,
    quickLaunchOrder: 0,
    iconPath: undefined,
    techBrief: undefined,
    skipAutoTasks: false,
    tabConfigs: [],
    tabLayout: undefined,
    taskPrompt: undefined,
    userStoryPrompt: undefined,
  };
}

export const ProjectTemplateDetails: MessageFns<ProjectTemplateDetails> = {
  encode(message: ProjectTemplateDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.requirements !== undefined) {
      ProjectTemplateDetails_Requirements.encode(message.requirements, writer.uint32(18).fork()).join();
    }
    if (message.plan !== undefined) {
      ProjectTemplateDetails_Plan.encode(message.plan, writer.uint32(26).fork()).join();
    }
    if (message.planItem !== undefined) {
      ProjectTemplateDetails_PlanItem.encode(message.planItem, writer.uint32(34).fork()).join();
    }
    if (message.planSubItem !== undefined) {
      ProjectTemplateDetails_PlanSubItem.encode(message.planSubItem, writer.uint32(42).fork()).join();
    }
    if (message.quickLaunchOrder !== 0) {
      writer.uint32(48).int32(message.quickLaunchOrder);
    }
    if (message.iconPath !== undefined) {
      writer.uint32(58).string(message.iconPath);
    }
    if (message.techBrief !== undefined) {
      ProjectTemplateDetails_TechBrief.encode(message.techBrief, writer.uint32(66).fork()).join();
    }
    if (message.skipAutoTasks !== false) {
      writer.uint32(72).bool(message.skipAutoTasks);
    }
    for (const v of message.tabConfigs) {
      ProjectTemplateDetails_ProjectTemplateTabConfig.encode(v!, writer.uint32(82).fork()).join();
    }
    if (message.tabLayout !== undefined) {
      ProjectTabLayout.encode(message.tabLayout, writer.uint32(90).fork()).join();
    }
    if (message.taskPrompt !== undefined) {
      ProjectTemplateDetails_TaskPrompt.encode(message.taskPrompt, writer.uint32(98).fork()).join();
    }
    if (message.userStoryPrompt !== undefined) {
      ProjectTemplateDetails_UserStoryPrompt.encode(message.userStoryPrompt, writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectTemplateDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectTemplateDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.requirements = ProjectTemplateDetails_Requirements.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.plan = ProjectTemplateDetails_Plan.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.planItem = ProjectTemplateDetails_PlanItem.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.planSubItem = ProjectTemplateDetails_PlanSubItem.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.quickLaunchOrder = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.iconPath = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.techBrief = ProjectTemplateDetails_TechBrief.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.skipAutoTasks = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.tabConfigs.push(ProjectTemplateDetails_ProjectTemplateTabConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.tabLayout = ProjectTabLayout.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.taskPrompt = ProjectTemplateDetails_TaskPrompt.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.userStoryPrompt = ProjectTemplateDetails_UserStoryPrompt.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectTemplateDetails {
    return {
      requirements: isSet(object.requirements)
        ? ProjectTemplateDetails_Requirements.fromJSON(object.requirements)
        : undefined,
      plan: isSet(object.plan) ? ProjectTemplateDetails_Plan.fromJSON(object.plan) : undefined,
      planItem: isSet(object.planItem)
        ? ProjectTemplateDetails_PlanItem.fromJSON(object.planItem)
        : isSet(object.plan_item)
        ? ProjectTemplateDetails_PlanItem.fromJSON(object.plan_item)
        : undefined,
      planSubItem: isSet(object.planSubItem)
        ? ProjectTemplateDetails_PlanSubItem.fromJSON(object.planSubItem)
        : isSet(object.plan_sub_item)
        ? ProjectTemplateDetails_PlanSubItem.fromJSON(object.plan_sub_item)
        : undefined,
      quickLaunchOrder: isSet(object.quickLaunchOrder)
        ? globalThis.Number(object.quickLaunchOrder)
        : isSet(object.quick_launch_order)
        ? globalThis.Number(object.quick_launch_order)
        : 0,
      iconPath: isSet(object.iconPath)
        ? globalThis.String(object.iconPath)
        : isSet(object.icon_path)
        ? globalThis.String(object.icon_path)
        : undefined,
      techBrief: isSet(object.techBrief)
        ? ProjectTemplateDetails_TechBrief.fromJSON(object.techBrief)
        : isSet(object.tech_brief)
        ? ProjectTemplateDetails_TechBrief.fromJSON(object.tech_brief)
        : undefined,
      skipAutoTasks: isSet(object.skipAutoTasks)
        ? globalThis.Boolean(object.skipAutoTasks)
        : isSet(object.skip_auto_tasks)
        ? globalThis.Boolean(object.skip_auto_tasks)
        : false,
      tabConfigs: globalThis.Array.isArray(object?.tabConfigs)
        ? object.tabConfigs.map((e: any) => ProjectTemplateDetails_ProjectTemplateTabConfig.fromJSON(e))
        : globalThis.Array.isArray(object?.tab_configs)
        ? object.tab_configs.map((e: any) => ProjectTemplateDetails_ProjectTemplateTabConfig.fromJSON(e))
        : [],
      tabLayout: isSet(object.tabLayout)
        ? ProjectTabLayout.fromJSON(object.tabLayout)
        : isSet(object.tab_layout)
        ? ProjectTabLayout.fromJSON(object.tab_layout)
        : undefined,
      taskPrompt: isSet(object.taskPrompt)
        ? ProjectTemplateDetails_TaskPrompt.fromJSON(object.taskPrompt)
        : isSet(object.task_prompt)
        ? ProjectTemplateDetails_TaskPrompt.fromJSON(object.task_prompt)
        : undefined,
      userStoryPrompt: isSet(object.userStoryPrompt)
        ? ProjectTemplateDetails_UserStoryPrompt.fromJSON(object.userStoryPrompt)
        : isSet(object.user_story_prompt)
        ? ProjectTemplateDetails_UserStoryPrompt.fromJSON(object.user_story_prompt)
        : undefined,
    };
  },

  toJSON(message: ProjectTemplateDetails): unknown {
    const obj: any = {};
    if (message.requirements !== undefined) {
      obj.requirements = ProjectTemplateDetails_Requirements.toJSON(message.requirements);
    }
    if (message.plan !== undefined) {
      obj.plan = ProjectTemplateDetails_Plan.toJSON(message.plan);
    }
    if (message.planItem !== undefined) {
      obj.planItem = ProjectTemplateDetails_PlanItem.toJSON(message.planItem);
    }
    if (message.planSubItem !== undefined) {
      obj.planSubItem = ProjectTemplateDetails_PlanSubItem.toJSON(message.planSubItem);
    }
    if (message.quickLaunchOrder !== 0) {
      obj.quickLaunchOrder = Math.round(message.quickLaunchOrder);
    }
    if (message.iconPath !== undefined) {
      obj.iconPath = message.iconPath;
    }
    if (message.techBrief !== undefined) {
      obj.techBrief = ProjectTemplateDetails_TechBrief.toJSON(message.techBrief);
    }
    if (message.skipAutoTasks !== false) {
      obj.skipAutoTasks = message.skipAutoTasks;
    }
    if (message.tabConfigs?.length) {
      obj.tabConfigs = message.tabConfigs.map((e) => ProjectTemplateDetails_ProjectTemplateTabConfig.toJSON(e));
    }
    if (message.tabLayout !== undefined) {
      obj.tabLayout = ProjectTabLayout.toJSON(message.tabLayout);
    }
    if (message.taskPrompt !== undefined) {
      obj.taskPrompt = ProjectTemplateDetails_TaskPrompt.toJSON(message.taskPrompt);
    }
    if (message.userStoryPrompt !== undefined) {
      obj.userStoryPrompt = ProjectTemplateDetails_UserStoryPrompt.toJSON(message.userStoryPrompt);
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectTemplateDetails>): ProjectTemplateDetails {
    return ProjectTemplateDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectTemplateDetails>): ProjectTemplateDetails {
    const message = createBaseProjectTemplateDetails();
    message.requirements = (object.requirements !== undefined && object.requirements !== null)
      ? ProjectTemplateDetails_Requirements.fromPartial(object.requirements)
      : undefined;
    message.plan = (object.plan !== undefined && object.plan !== null)
      ? ProjectTemplateDetails_Plan.fromPartial(object.plan)
      : undefined;
    message.planItem = (object.planItem !== undefined && object.planItem !== null)
      ? ProjectTemplateDetails_PlanItem.fromPartial(object.planItem)
      : undefined;
    message.planSubItem = (object.planSubItem !== undefined && object.planSubItem !== null)
      ? ProjectTemplateDetails_PlanSubItem.fromPartial(object.planSubItem)
      : undefined;
    message.quickLaunchOrder = object.quickLaunchOrder ?? 0;
    message.iconPath = object.iconPath ?? undefined;
    message.techBrief = (object.techBrief !== undefined && object.techBrief !== null)
      ? ProjectTemplateDetails_TechBrief.fromPartial(object.techBrief)
      : undefined;
    message.skipAutoTasks = object.skipAutoTasks ?? false;
    message.tabConfigs =
      object.tabConfigs?.map((e) => ProjectTemplateDetails_ProjectTemplateTabConfig.fromPartial(e)) || [];
    message.tabLayout = (object.tabLayout !== undefined && object.tabLayout !== null)
      ? ProjectTabLayout.fromPartial(object.tabLayout)
      : undefined;
    message.taskPrompt = (object.taskPrompt !== undefined && object.taskPrompt !== null)
      ? ProjectTemplateDetails_TaskPrompt.fromPartial(object.taskPrompt)
      : undefined;
    message.userStoryPrompt = (object.userStoryPrompt !== undefined && object.userStoryPrompt !== null)
      ? ProjectTemplateDetails_UserStoryPrompt.fromPartial(object.userStoryPrompt)
      : undefined;
    return message;
  },
};

function createBaseProjectTemplateDetails_Requirements(): ProjectTemplateDetails_Requirements {
  return { info: undefined };
}

export const ProjectTemplateDetails_Requirements: MessageFns<ProjectTemplateDetails_Requirements> = {
  encode(message: ProjectTemplateDetails_Requirements, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.info !== undefined) {
      ProjectTemplateInfo.encode(message.info, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectTemplateDetails_Requirements {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectTemplateDetails_Requirements();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = ProjectTemplateInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectTemplateDetails_Requirements {
    return { info: isSet(object.info) ? ProjectTemplateInfo.fromJSON(object.info) : undefined };
  },

  toJSON(message: ProjectTemplateDetails_Requirements): unknown {
    const obj: any = {};
    if (message.info !== undefined) {
      obj.info = ProjectTemplateInfo.toJSON(message.info);
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectTemplateDetails_Requirements>): ProjectTemplateDetails_Requirements {
    return ProjectTemplateDetails_Requirements.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectTemplateDetails_Requirements>): ProjectTemplateDetails_Requirements {
    const message = createBaseProjectTemplateDetails_Requirements();
    message.info = (object.info !== undefined && object.info !== null)
      ? ProjectTemplateInfo.fromPartial(object.info)
      : undefined;
    return message;
  },
};

function createBaseProjectTemplateDetails_Plan(): ProjectTemplateDetails_Plan {
  return { info: undefined, hide: false };
}

export const ProjectTemplateDetails_Plan: MessageFns<ProjectTemplateDetails_Plan> = {
  encode(message: ProjectTemplateDetails_Plan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.info !== undefined) {
      ProjectTemplateInfo.encode(message.info, writer.uint32(10).fork()).join();
    }
    if (message.hide !== false) {
      writer.uint32(16).bool(message.hide);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectTemplateDetails_Plan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectTemplateDetails_Plan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = ProjectTemplateInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.hide = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectTemplateDetails_Plan {
    return {
      info: isSet(object.info) ? ProjectTemplateInfo.fromJSON(object.info) : undefined,
      hide: isSet(object.hide) ? globalThis.Boolean(object.hide) : false,
    };
  },

  toJSON(message: ProjectTemplateDetails_Plan): unknown {
    const obj: any = {};
    if (message.info !== undefined) {
      obj.info = ProjectTemplateInfo.toJSON(message.info);
    }
    if (message.hide !== false) {
      obj.hide = message.hide;
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectTemplateDetails_Plan>): ProjectTemplateDetails_Plan {
    return ProjectTemplateDetails_Plan.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectTemplateDetails_Plan>): ProjectTemplateDetails_Plan {
    const message = createBaseProjectTemplateDetails_Plan();
    message.info = (object.info !== undefined && object.info !== null)
      ? ProjectTemplateInfo.fromPartial(object.info)
      : undefined;
    message.hide = object.hide ?? false;
    return message;
  },
};

function createBaseProjectTemplateDetails_PlanItem(): ProjectTemplateDetails_PlanItem {
  return { info: undefined };
}

export const ProjectTemplateDetails_PlanItem: MessageFns<ProjectTemplateDetails_PlanItem> = {
  encode(message: ProjectTemplateDetails_PlanItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.info !== undefined) {
      ProjectTemplateInfo.encode(message.info, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectTemplateDetails_PlanItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectTemplateDetails_PlanItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = ProjectTemplateInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectTemplateDetails_PlanItem {
    return { info: isSet(object.info) ? ProjectTemplateInfo.fromJSON(object.info) : undefined };
  },

  toJSON(message: ProjectTemplateDetails_PlanItem): unknown {
    const obj: any = {};
    if (message.info !== undefined) {
      obj.info = ProjectTemplateInfo.toJSON(message.info);
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectTemplateDetails_PlanItem>): ProjectTemplateDetails_PlanItem {
    return ProjectTemplateDetails_PlanItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectTemplateDetails_PlanItem>): ProjectTemplateDetails_PlanItem {
    const message = createBaseProjectTemplateDetails_PlanItem();
    message.info = (object.info !== undefined && object.info !== null)
      ? ProjectTemplateInfo.fromPartial(object.info)
      : undefined;
    return message;
  },
};

function createBaseProjectTemplateDetails_PlanSubItem(): ProjectTemplateDetails_PlanSubItem {
  return { info: undefined };
}

export const ProjectTemplateDetails_PlanSubItem: MessageFns<ProjectTemplateDetails_PlanSubItem> = {
  encode(message: ProjectTemplateDetails_PlanSubItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.info !== undefined) {
      ProjectTemplateInfo.encode(message.info, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectTemplateDetails_PlanSubItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectTemplateDetails_PlanSubItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = ProjectTemplateInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectTemplateDetails_PlanSubItem {
    return { info: isSet(object.info) ? ProjectTemplateInfo.fromJSON(object.info) : undefined };
  },

  toJSON(message: ProjectTemplateDetails_PlanSubItem): unknown {
    const obj: any = {};
    if (message.info !== undefined) {
      obj.info = ProjectTemplateInfo.toJSON(message.info);
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectTemplateDetails_PlanSubItem>): ProjectTemplateDetails_PlanSubItem {
    return ProjectTemplateDetails_PlanSubItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectTemplateDetails_PlanSubItem>): ProjectTemplateDetails_PlanSubItem {
    const message = createBaseProjectTemplateDetails_PlanSubItem();
    message.info = (object.info !== undefined && object.info !== null)
      ? ProjectTemplateInfo.fromPartial(object.info)
      : undefined;
    return message;
  },
};

function createBaseProjectTemplateDetails_TechBrief(): ProjectTemplateDetails_TechBrief {
  return { info: undefined };
}

export const ProjectTemplateDetails_TechBrief: MessageFns<ProjectTemplateDetails_TechBrief> = {
  encode(message: ProjectTemplateDetails_TechBrief, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.info !== undefined) {
      ProjectTemplateInfo.encode(message.info, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectTemplateDetails_TechBrief {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectTemplateDetails_TechBrief();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = ProjectTemplateInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectTemplateDetails_TechBrief {
    return { info: isSet(object.info) ? ProjectTemplateInfo.fromJSON(object.info) : undefined };
  },

  toJSON(message: ProjectTemplateDetails_TechBrief): unknown {
    const obj: any = {};
    if (message.info !== undefined) {
      obj.info = ProjectTemplateInfo.toJSON(message.info);
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectTemplateDetails_TechBrief>): ProjectTemplateDetails_TechBrief {
    return ProjectTemplateDetails_TechBrief.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectTemplateDetails_TechBrief>): ProjectTemplateDetails_TechBrief {
    const message = createBaseProjectTemplateDetails_TechBrief();
    message.info = (object.info !== undefined && object.info !== null)
      ? ProjectTemplateInfo.fromPartial(object.info)
      : undefined;
    return message;
  },
};

function createBaseProjectTemplateDetails_TaskPrompt(): ProjectTemplateDetails_TaskPrompt {
  return { info: undefined };
}

export const ProjectTemplateDetails_TaskPrompt: MessageFns<ProjectTemplateDetails_TaskPrompt> = {
  encode(message: ProjectTemplateDetails_TaskPrompt, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.info !== undefined) {
      ProjectTemplateInfo.encode(message.info, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectTemplateDetails_TaskPrompt {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectTemplateDetails_TaskPrompt();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = ProjectTemplateInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectTemplateDetails_TaskPrompt {
    return { info: isSet(object.info) ? ProjectTemplateInfo.fromJSON(object.info) : undefined };
  },

  toJSON(message: ProjectTemplateDetails_TaskPrompt): unknown {
    const obj: any = {};
    if (message.info !== undefined) {
      obj.info = ProjectTemplateInfo.toJSON(message.info);
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectTemplateDetails_TaskPrompt>): ProjectTemplateDetails_TaskPrompt {
    return ProjectTemplateDetails_TaskPrompt.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectTemplateDetails_TaskPrompt>): ProjectTemplateDetails_TaskPrompt {
    const message = createBaseProjectTemplateDetails_TaskPrompt();
    message.info = (object.info !== undefined && object.info !== null)
      ? ProjectTemplateInfo.fromPartial(object.info)
      : undefined;
    return message;
  },
};

function createBaseProjectTemplateDetails_UserStoryPrompt(): ProjectTemplateDetails_UserStoryPrompt {
  return { info: undefined };
}

export const ProjectTemplateDetails_UserStoryPrompt: MessageFns<ProjectTemplateDetails_UserStoryPrompt> = {
  encode(message: ProjectTemplateDetails_UserStoryPrompt, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.info !== undefined) {
      ProjectTemplateInfo.encode(message.info, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectTemplateDetails_UserStoryPrompt {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectTemplateDetails_UserStoryPrompt();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = ProjectTemplateInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectTemplateDetails_UserStoryPrompt {
    return { info: isSet(object.info) ? ProjectTemplateInfo.fromJSON(object.info) : undefined };
  },

  toJSON(message: ProjectTemplateDetails_UserStoryPrompt): unknown {
    const obj: any = {};
    if (message.info !== undefined) {
      obj.info = ProjectTemplateInfo.toJSON(message.info);
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectTemplateDetails_UserStoryPrompt>): ProjectTemplateDetails_UserStoryPrompt {
    return ProjectTemplateDetails_UserStoryPrompt.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectTemplateDetails_UserStoryPrompt>): ProjectTemplateDetails_UserStoryPrompt {
    const message = createBaseProjectTemplateDetails_UserStoryPrompt();
    message.info = (object.info !== undefined && object.info !== null)
      ? ProjectTemplateInfo.fromPartial(object.info)
      : undefined;
    return message;
  },
};

function createBaseProjectTemplateDetails_ProjectTemplateTabConfig(): ProjectTemplateDetails_ProjectTemplateTabConfig {
  return { templateId: "", order: 0, asTab: false };
}

export const ProjectTemplateDetails_ProjectTemplateTabConfig: MessageFns<
  ProjectTemplateDetails_ProjectTemplateTabConfig
> = {
  encode(
    message: ProjectTemplateDetails_ProjectTemplateTabConfig,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.templateId !== "") {
      writer.uint32(10).string(message.templateId);
    }
    if (message.order !== 0) {
      writer.uint32(16).int32(message.order);
    }
    if (message.asTab !== false) {
      writer.uint32(24).bool(message.asTab);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectTemplateDetails_ProjectTemplateTabConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectTemplateDetails_ProjectTemplateTabConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.templateId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.order = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.asTab = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectTemplateDetails_ProjectTemplateTabConfig {
    return {
      templateId: isSet(object.templateId)
        ? globalThis.String(object.templateId)
        : isSet(object.template_id)
        ? globalThis.String(object.template_id)
        : "",
      order: isSet(object.order) ? globalThis.Number(object.order) : 0,
      asTab: isSet(object.asTab)
        ? globalThis.Boolean(object.asTab)
        : isSet(object.as_tab)
        ? globalThis.Boolean(object.as_tab)
        : false,
    };
  },

  toJSON(message: ProjectTemplateDetails_ProjectTemplateTabConfig): unknown {
    const obj: any = {};
    if (message.templateId !== "") {
      obj.templateId = message.templateId;
    }
    if (message.order !== 0) {
      obj.order = Math.round(message.order);
    }
    if (message.asTab !== false) {
      obj.asTab = message.asTab;
    }
    return obj;
  },

  create(
    base?: DeepPartial<ProjectTemplateDetails_ProjectTemplateTabConfig>,
  ): ProjectTemplateDetails_ProjectTemplateTabConfig {
    return ProjectTemplateDetails_ProjectTemplateTabConfig.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<ProjectTemplateDetails_ProjectTemplateTabConfig>,
  ): ProjectTemplateDetails_ProjectTemplateTabConfig {
    const message = createBaseProjectTemplateDetails_ProjectTemplateTabConfig();
    message.templateId = object.templateId ?? "";
    message.order = object.order ?? 0;
    message.asTab = object.asTab ?? false;
    return message;
  },
};

function createBaseCustomDocumentSettings(): CustomDocumentSettings {
  return {
    iconPath: undefined,
    unique: false,
    showAsTab: false,
    noGenerationOnStart: false,
    initialMessage: undefined,
    initialSystemPrompt: undefined,
  };
}

export const CustomDocumentSettings: MessageFns<CustomDocumentSettings> = {
  encode(message: CustomDocumentSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.iconPath !== undefined) {
      writer.uint32(10).string(message.iconPath);
    }
    if (message.unique !== false) {
      writer.uint32(16).bool(message.unique);
    }
    if (message.showAsTab !== false) {
      writer.uint32(24).bool(message.showAsTab);
    }
    if (message.noGenerationOnStart !== false) {
      writer.uint32(40).bool(message.noGenerationOnStart);
    }
    if (message.initialMessage !== undefined) {
      writer.uint32(50).string(message.initialMessage);
    }
    if (message.initialSystemPrompt !== undefined) {
      writer.uint32(58).string(message.initialSystemPrompt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CustomDocumentSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomDocumentSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.iconPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.unique = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.showAsTab = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.noGenerationOnStart = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.initialMessage = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.initialSystemPrompt = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CustomDocumentSettings {
    return {
      iconPath: isSet(object.iconPath)
        ? globalThis.String(object.iconPath)
        : isSet(object.icon_path)
        ? globalThis.String(object.icon_path)
        : undefined,
      unique: isSet(object.unique) ? globalThis.Boolean(object.unique) : false,
      showAsTab: isSet(object.showAsTab)
        ? globalThis.Boolean(object.showAsTab)
        : isSet(object.show_as_tab)
        ? globalThis.Boolean(object.show_as_tab)
        : false,
      noGenerationOnStart: isSet(object.noGenerationOnStart)
        ? globalThis.Boolean(object.noGenerationOnStart)
        : isSet(object.no_generation_on_start)
        ? globalThis.Boolean(object.no_generation_on_start)
        : false,
      initialMessage: isSet(object.initialMessage)
        ? globalThis.String(object.initialMessage)
        : isSet(object.initial_message)
        ? globalThis.String(object.initial_message)
        : undefined,
      initialSystemPrompt: isSet(object.initialSystemPrompt)
        ? globalThis.String(object.initialSystemPrompt)
        : isSet(object.initial_system_prompt)
        ? globalThis.String(object.initial_system_prompt)
        : undefined,
    };
  },

  toJSON(message: CustomDocumentSettings): unknown {
    const obj: any = {};
    if (message.iconPath !== undefined) {
      obj.iconPath = message.iconPath;
    }
    if (message.unique !== false) {
      obj.unique = message.unique;
    }
    if (message.showAsTab !== false) {
      obj.showAsTab = message.showAsTab;
    }
    if (message.noGenerationOnStart !== false) {
      obj.noGenerationOnStart = message.noGenerationOnStart;
    }
    if (message.initialMessage !== undefined) {
      obj.initialMessage = message.initialMessage;
    }
    if (message.initialSystemPrompt !== undefined) {
      obj.initialSystemPrompt = message.initialSystemPrompt;
    }
    return obj;
  },

  create(base?: DeepPartial<CustomDocumentSettings>): CustomDocumentSettings {
    return CustomDocumentSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CustomDocumentSettings>): CustomDocumentSettings {
    const message = createBaseCustomDocumentSettings();
    message.iconPath = object.iconPath ?? undefined;
    message.unique = object.unique ?? false;
    message.showAsTab = object.showAsTab ?? false;
    message.noGenerationOnStart = object.noGenerationOnStart ?? false;
    message.initialMessage = object.initialMessage ?? undefined;
    message.initialSystemPrompt = object.initialSystemPrompt ?? undefined;
    return message;
  },
};

function createBaseCustomDocumentTemplate(): CustomDocumentTemplate {
  return {
    settings: undefined,
    generationPlan: undefined,
    generationPrompt: undefined,
    critiquePrompt: undefined,
    initialCritiqueLoops: 0,
    critiqueLoops: 0,
    chatPrompt: undefined,
    confirmationPrompt: undefined,
  };
}

export const CustomDocumentTemplate: MessageFns<CustomDocumentTemplate> = {
  encode(message: CustomDocumentTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.settings !== undefined) {
      CustomDocumentSettings.encode(message.settings, writer.uint32(10).fork()).join();
    }
    if (message.generationPlan !== undefined) {
      GenerationPlan.encode(message.generationPlan, writer.uint32(18).fork()).join();
    }
    if (message.generationPrompt !== undefined) {
      PromptTemplate.encode(message.generationPrompt, writer.uint32(26).fork()).join();
    }
    if (message.critiquePrompt !== undefined) {
      PromptTemplate.encode(message.critiquePrompt, writer.uint32(34).fork()).join();
    }
    if (message.initialCritiqueLoops !== 0) {
      writer.uint32(40).int32(message.initialCritiqueLoops);
    }
    if (message.critiqueLoops !== 0) {
      writer.uint32(48).int32(message.critiqueLoops);
    }
    if (message.chatPrompt !== undefined) {
      PromptTemplate.encode(message.chatPrompt, writer.uint32(58).fork()).join();
    }
    if (message.confirmationPrompt !== undefined) {
      PromptTemplate.encode(message.confirmationPrompt, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CustomDocumentTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomDocumentTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settings = CustomDocumentSettings.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.generationPlan = GenerationPlan.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.generationPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.critiquePrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.initialCritiqueLoops = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.critiqueLoops = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.chatPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.confirmationPrompt = PromptTemplate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CustomDocumentTemplate {
    return {
      settings: isSet(object.settings) ? CustomDocumentSettings.fromJSON(object.settings) : undefined,
      generationPlan: isSet(object.generationPlan)
        ? GenerationPlan.fromJSON(object.generationPlan)
        : isSet(object.generation_plan)
        ? GenerationPlan.fromJSON(object.generation_plan)
        : undefined,
      generationPrompt: isSet(object.generationPrompt)
        ? PromptTemplate.fromJSON(object.generationPrompt)
        : isSet(object.generation_prompt)
        ? PromptTemplate.fromJSON(object.generation_prompt)
        : undefined,
      critiquePrompt: isSet(object.critiquePrompt)
        ? PromptTemplate.fromJSON(object.critiquePrompt)
        : isSet(object.critique_prompt)
        ? PromptTemplate.fromJSON(object.critique_prompt)
        : undefined,
      initialCritiqueLoops: isSet(object.initialCritiqueLoops)
        ? globalThis.Number(object.initialCritiqueLoops)
        : isSet(object.initial_critique_loops)
        ? globalThis.Number(object.initial_critique_loops)
        : 0,
      critiqueLoops: isSet(object.critiqueLoops)
        ? globalThis.Number(object.critiqueLoops)
        : isSet(object.critique_loops)
        ? globalThis.Number(object.critique_loops)
        : 0,
      chatPrompt: isSet(object.chatPrompt)
        ? PromptTemplate.fromJSON(object.chatPrompt)
        : isSet(object.chat_prompt)
        ? PromptTemplate.fromJSON(object.chat_prompt)
        : undefined,
      confirmationPrompt: isSet(object.confirmationPrompt)
        ? PromptTemplate.fromJSON(object.confirmationPrompt)
        : isSet(object.confirmation_prompt)
        ? PromptTemplate.fromJSON(object.confirmation_prompt)
        : undefined,
    };
  },

  toJSON(message: CustomDocumentTemplate): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = CustomDocumentSettings.toJSON(message.settings);
    }
    if (message.generationPlan !== undefined) {
      obj.generationPlan = GenerationPlan.toJSON(message.generationPlan);
    }
    if (message.generationPrompt !== undefined) {
      obj.generationPrompt = PromptTemplate.toJSON(message.generationPrompt);
    }
    if (message.critiquePrompt !== undefined) {
      obj.critiquePrompt = PromptTemplate.toJSON(message.critiquePrompt);
    }
    if (message.initialCritiqueLoops !== 0) {
      obj.initialCritiqueLoops = Math.round(message.initialCritiqueLoops);
    }
    if (message.critiqueLoops !== 0) {
      obj.critiqueLoops = Math.round(message.critiqueLoops);
    }
    if (message.chatPrompt !== undefined) {
      obj.chatPrompt = PromptTemplate.toJSON(message.chatPrompt);
    }
    if (message.confirmationPrompt !== undefined) {
      obj.confirmationPrompt = PromptTemplate.toJSON(message.confirmationPrompt);
    }
    return obj;
  },

  create(base?: DeepPartial<CustomDocumentTemplate>): CustomDocumentTemplate {
    return CustomDocumentTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CustomDocumentTemplate>): CustomDocumentTemplate {
    const message = createBaseCustomDocumentTemplate();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? CustomDocumentSettings.fromPartial(object.settings)
      : undefined;
    message.generationPlan = (object.generationPlan !== undefined && object.generationPlan !== null)
      ? GenerationPlan.fromPartial(object.generationPlan)
      : undefined;
    message.generationPrompt = (object.generationPrompt !== undefined && object.generationPrompt !== null)
      ? PromptTemplate.fromPartial(object.generationPrompt)
      : undefined;
    message.critiquePrompt = (object.critiquePrompt !== undefined && object.critiquePrompt !== null)
      ? PromptTemplate.fromPartial(object.critiquePrompt)
      : undefined;
    message.initialCritiqueLoops = object.initialCritiqueLoops ?? 0;
    message.critiqueLoops = object.critiqueLoops ?? 0;
    message.chatPrompt = (object.chatPrompt !== undefined && object.chatPrompt !== null)
      ? PromptTemplate.fromPartial(object.chatPrompt)
      : undefined;
    message.confirmationPrompt = (object.confirmationPrompt !== undefined && object.confirmationPrompt !== null)
      ? PromptTemplate.fromPartial(object.confirmationPrompt)
      : undefined;
    return message;
  },
};

function createBaseCodeAssistantRule(): CodeAssistantRule {
  return { name: "", extension: "", assistantType: 0, type: undefined };
}

export const CodeAssistantRule: MessageFns<CodeAssistantRule> = {
  encode(message: CodeAssistantRule, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.extension !== "") {
      writer.uint32(18).string(message.extension);
    }
    if (message.assistantType !== 0) {
      writer.uint32(24).int32(message.assistantType);
    }
    switch (message.type?.$case) {
      case "templateId":
        writer.uint32(802).string(message.type.value);
        break;
      case "static":
        writer.uint32(810).string(message.type.value);
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CodeAssistantRule {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCodeAssistantRule();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.extension = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.assistantType = reader.int32() as any;
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.type = { $case: "templateId", value: reader.string() };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.type = { $case: "static", value: reader.string() };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CodeAssistantRule {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      extension: isSet(object.extension) ? globalThis.String(object.extension) : "",
      assistantType: isSet(object.assistantType)
        ? codeAssistantTypeFromJSON(object.assistantType)
        : isSet(object.assistant_type)
        ? codeAssistantTypeFromJSON(object.assistant_type)
        : 0,
      type: isSet(object.templateId)
        ? { $case: "templateId", value: globalThis.String(object.templateId) }
        : isSet(object.template_id)
        ? { $case: "templateId", value: globalThis.String(object.template_id) }
        : isSet(object.static)
        ? { $case: "static", value: globalThis.String(object.static) }
        : undefined,
    };
  },

  toJSON(message: CodeAssistantRule): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.extension !== "") {
      obj.extension = message.extension;
    }
    if (message.assistantType !== 0) {
      obj.assistantType = codeAssistantTypeToJSON(message.assistantType);
    }
    if (message.type?.$case === "templateId") {
      obj.templateId = message.type.value;
    } else if (message.type?.$case === "static") {
      obj.static = message.type.value;
    }
    return obj;
  },

  create(base?: DeepPartial<CodeAssistantRule>): CodeAssistantRule {
    return CodeAssistantRule.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CodeAssistantRule>): CodeAssistantRule {
    const message = createBaseCodeAssistantRule();
    message.name = object.name ?? "";
    message.extension = object.extension ?? "";
    message.assistantType = object.assistantType ?? 0;
    switch (object.type?.$case) {
      case "templateId": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "templateId", value: object.type.value };
        }
        break;
      }
      case "static": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "static", value: object.type.value };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseCodingAssistantTemplate(): CodingAssistantTemplate {
  return {
    fullPromptTemplateId: undefined,
    perFeatureTemplateId: undefined,
    steppedPerFeatureTemplateId: undefined,
    ruleFiles: [],
  };
}

export const CodingAssistantTemplate: MessageFns<CodingAssistantTemplate> = {
  encode(message: CodingAssistantTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fullPromptTemplateId !== undefined) {
      writer.uint32(10).string(message.fullPromptTemplateId);
    }
    if (message.perFeatureTemplateId !== undefined) {
      writer.uint32(18).string(message.perFeatureTemplateId);
    }
    if (message.steppedPerFeatureTemplateId !== undefined) {
      writer.uint32(42).string(message.steppedPerFeatureTemplateId);
    }
    for (const v of message.ruleFiles) {
      CodeAssistantRule.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CodingAssistantTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCodingAssistantTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fullPromptTemplateId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.perFeatureTemplateId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.steppedPerFeatureTemplateId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ruleFiles.push(CodeAssistantRule.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CodingAssistantTemplate {
    return {
      fullPromptTemplateId: isSet(object.fullPromptTemplateId)
        ? globalThis.String(object.fullPromptTemplateId)
        : isSet(object.full_prompt_template_id)
        ? globalThis.String(object.full_prompt_template_id)
        : undefined,
      perFeatureTemplateId: isSet(object.perFeatureTemplateId)
        ? globalThis.String(object.perFeatureTemplateId)
        : isSet(object.per_feature_template_id)
        ? globalThis.String(object.per_feature_template_id)
        : undefined,
      steppedPerFeatureTemplateId: isSet(object.steppedPerFeatureTemplateId)
        ? globalThis.String(object.steppedPerFeatureTemplateId)
        : isSet(object.stepped_per_feature_template_id)
        ? globalThis.String(object.stepped_per_feature_template_id)
        : undefined,
      ruleFiles: globalThis.Array.isArray(object?.ruleFiles)
        ? object.ruleFiles.map((e: any) => CodeAssistantRule.fromJSON(e))
        : globalThis.Array.isArray(object?.rule_files)
        ? object.rule_files.map((e: any) => CodeAssistantRule.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CodingAssistantTemplate): unknown {
    const obj: any = {};
    if (message.fullPromptTemplateId !== undefined) {
      obj.fullPromptTemplateId = message.fullPromptTemplateId;
    }
    if (message.perFeatureTemplateId !== undefined) {
      obj.perFeatureTemplateId = message.perFeatureTemplateId;
    }
    if (message.steppedPerFeatureTemplateId !== undefined) {
      obj.steppedPerFeatureTemplateId = message.steppedPerFeatureTemplateId;
    }
    if (message.ruleFiles?.length) {
      obj.ruleFiles = message.ruleFiles.map((e) => CodeAssistantRule.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<CodingAssistantTemplate>): CodingAssistantTemplate {
    return CodingAssistantTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CodingAssistantTemplate>): CodingAssistantTemplate {
    const message = createBaseCodingAssistantTemplate();
    message.fullPromptTemplateId = object.fullPromptTemplateId ?? undefined;
    message.perFeatureTemplateId = object.perFeatureTemplateId ?? undefined;
    message.steppedPerFeatureTemplateId = object.steppedPerFeatureTemplateId ?? undefined;
    message.ruleFiles = object.ruleFiles?.map((e) => CodeAssistantRule.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
